import React, { useState, useEffect } from 'react';
import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { Users, User, BarChart3, LogOut, CreditCard, Calendar, TrendingUp, UserPlus, RefreshCcw, DollarSign, PieChart, Bell, Send, Mail, Database, Download, Settings, CheckCircle, XCircle, Loader2, Stethoscope, Building2, Save, ExternalLink, Eye, FileText, BookOpen, RotateCcw, AlertTriangle, MessageSquare, Edit, Trash2, RefreshCw, ChevronLeft, ChevronRight, X, Check, Menu, Home, Star, Package, Clock, QrCode, Share2, Shield, Film, Tag, Plus, Brain, Video, MapPin } from 'lucide-react';
import { toast } from 'sonner';
import NotificationBell from '../components/NotificationBell';
import MessageBell from '../components/MessageBell';
import { InternalMessages } from '../components/InternalMessages';
import Breadcrumb from '../components/Breadcrumb';
import ReviewForm from '../components/ReviewForm';
import ReviewsManagementTab from '../components/ReviewsManagementTab';
import InventoryManager from '../components/InventoryManager';
import ShiftsManager from '../components/ShiftsManager';
import HRReports from '../components/HRReports';
import PayrollManager from '../components/PayrollManager';
import CheckInManager from '../components/admin/CheckInManager';
import SocialMediaManager from '../components/admin/SocialMediaManager';
import ContentPlannerManager from '../components/admin/ContentPlannerManager';
import VideoSeriesManager from '../components/admin/VideoSeriesManager';
import AddPatientModal from '../components/admin/AddPatientModal';
import MLAnalyticsDashboard from '../components/admin/MLAnalyticsDashboard';
import DoctorsManager from '../components/admin/DoctorsManager';
import NewsletterManager from '../components/admin/NewsletterManager';
import { PrescribeProtocolForm } from '../components/PreventionProtocols';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AVAILABLE_ROOMS = ['Stanza A', 'Stanza B', 'Stanza C', 'Stanza D'];

export const AdminDashboard = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [user, setUser] = useState(null);
  const [stats, setStats] = useState(null);
  const [locationStats, setLocationStats] = useState(null);
  const [patients, setPatients] = useState([]);
  const [activeTab, setActiveTab] = useState(() => {
    // Leggi il tab iniziale dai parametri URL
    const urlTab = searchParams.get('tab');
    return urlTab || 'stats';
  });
  const [loading, setLoading] = useState(true);
  const [confirmations, setConfirmations] = useState([]);
  const [sendingReminders, setSendingReminders] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [configStatus, setConfigStatus] = useState(null);
  const [subscribers, setSubscribers] = useState([]);
  const [sendingNewsletter, setSendingNewsletter] = useState(false);
  const [creatingBackup, setCreatingBackup] = useState(false);
  const [patientSearch, setPatientSearch] = useState('');
  const [patientTypeFilter, setPatientTypeFilter] = useState('all'); // all, lead, naive, fidelizzato, abbonato
  // Newsletter state
  const [newsletterPreview, setNewsletterPreview] = useState(null);
  const [newsletterStep, setNewsletterStep] = useState('select'); // 'select', 'preview', 'confirm'
  const [selectedAgeBracket, setSelectedAgeBracket] = useState(null);
  const [selectedTheme, setSelectedTheme] = useState(null);
  const [newsletterType, setNewsletterType] = useState('age'); // 'age' or 'thematic'
  const [generatingPreview, setGeneratingPreview] = useState(false);
  // New: Newsletter Scheduler state
  const [schedulerStatus, setSchedulerStatus] = useState(null);
  const [loadingScheduler, setLoadingScheduler] = useState(false);
  const [triggeringScheduler, setTriggeringScheduler] = useState(false);
  // New: Doctors management
  const [doctors, setDoctors] = useState([]);
  const [loadingDoctors, setLoadingDoctors] = useState(false);
  const [savingDoctor, setSavingDoctor] = useState(null);
  const [showAddDoctorModal, setShowAddDoctorModal] = useState(false);
  const [newDoctorForm, setNewDoctorForm] = useState({ first_name: '', last_name: '', email: '', password: '', phone: '', specialization: '', staff_type: 'doctor', work_locations: ['milano', 'napoli'] });
  const [addingDoctor, setAddingDoctor] = useState(false);
  const [deletingDoctor, setDeletingDoctor] = useState(null);
  // New: Invoices
  const [invoices, setInvoices] = useState([]);
  const [loadingInvoices, setLoadingInvoices] = useState(false);
  const [invoiceFilter, setInvoiceFilter] = useState('all'); // 'all', 'patient', 'staff'
  const [invoiceStats, setInvoiceStats] = useState({});
  const [showCreateInvoiceModal, setShowCreateInvoiceModal] = useState(false);
  const [newInvoice, setNewInvoice] = useState({
    patient_id: '',
    patient_name: '',
    description: '',
    items: [{ description: 'Visita oculistica', amount: 100 }],
    amount: 100
  });
  
  // Add Patient Modal state (using new component)
  const [showAddPatientModal, setShowAddPatientModal] = useState(false);
  
  // Messages Modal state
  const [showMessagesModal, setShowMessagesModal] = useState(false);
  
  // New: Appointments Calendar Management
  const [allAppointments, setAllAppointments] = useState([]);
  const [loadingAppointments, setLoadingAppointments] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
  const [locationFilter, setLocationFilter] = useState('');
  const [calendarMonth, setCalendarMonth] = useState(new Date());
  const [editAppointmentModal, setEditAppointmentModal] = useState({ show: false, appointment: null });
  const [savingAppointment, setSavingAppointment] = useState(false);
  const [appointmentFilters, setAppointmentFilters] = useState({ doctor: '', status: '', room: '' });
  
  // New Appointment Modal states
  const [availableSlots, setAvailableSlots] = useState([]);
  const [loadingSlots, setLoadingSlots] = useState(false);
  const [patientSearchQuery, setPatientSearchQuery] = useState('');
  const [patientSearchResults, setPatientSearchResults] = useState([]);
  const [searchingPatients, setSearchingPatients] = useState(false);
  
  // Videoconsulti state
  const [allVideoConsults, setAllVideoConsults] = useState([]);
  
  // NEW: Modal dettagli statistiche
  const [statsDetailModal, setStatsDetailModal] = useState({ show: false, type: null, title: '', data: [] });
  const [loadingStatsDetail, setLoadingStatsDetail] = useState(false);
  
  // NEW: SEO Analytics
  const [seoData, setSeoData] = useState(null);
  const [loadingSeo, setLoadingSeo] = useState(false);
  
  const navigate = useNavigate();

  const AGE_BRACKETS = [
    { id: '20-35', label: '20-35 anni', description: 'Chirurgia refrattiva', icon: '✨' },
    { id: '36-55', label: '36-55 anni', description: 'Presbiopia', icon: '👓' },
    { id: '56-65', label: '56-65 anni', description: 'Cataratta refrattiva', icon: '💎' },
    { id: '66+', label: '66+ anni', description: 'Cataratta, Glaucoma, Maculopatia', icon: '🏥' }
  ];

  const THEMATIC_NEWSLETTERS = [
    // Temi mensili
    { id: 'gennaio_buoni_propositi', label: 'Gennaio', description: 'Nuovi obiettivi per la vista', icon: '🎯', month: 1 },
    { id: 'febbraio_san_valentino', label: 'Febbraio', description: 'Ama i tuoi occhi', icon: '❤️', month: 2 },
    { id: 'marzo_primavera', label: 'Marzo', description: 'Primavera e allergie', icon: '🌸', month: 3 },
    { id: 'aprile_prevenzione', label: 'Aprile', description: 'Mese della prevenzione', icon: '🏥', month: 4 },
    { id: 'maggio_luce_blu', label: 'Maggio', description: 'Protezione luce blu', icon: '💻', month: 5 },
    { id: 'giugno_sole', label: 'Giugno', description: 'Protezione dal sole', icon: '☀️', month: 6 },
    { id: 'luglio_vacanze', label: 'Luglio', description: 'Occhi in vacanza', icon: '🏖️', month: 7 },
    { id: 'agosto_relax', label: 'Agosto', description: 'Riposo visivo', icon: '😎', month: 8 },
    { id: 'settembre_ritorno', label: 'Settembre', description: 'Ritorno a scuola/lavoro', icon: '📚', month: 9 },
    { id: 'ottobre_prevenzione_mondiale', label: 'Ottobre', description: 'Giornata mondiale vista', icon: '🌍', month: 10 },
    { id: 'novembre_occhio_secco', label: 'Novembre', description: 'Occhio secco invernale', icon: '💧', month: 11 },
    { id: 'dicembre_regali', label: 'Dicembre', description: 'Regala la salute', icon: '🎁', month: 12 },
  ];

  useEffect(() => {
    const userData = localStorage.getItem('user');
    if (!userData) {
      navigate('/auth');
      return;
    }
    const parsedUser = JSON.parse(userData);
    if (parsedUser.role !== 'admin') {
      navigate('/');
      return;
    }
    setUser(parsedUser);
    loadData();
    
    // Auto-refresh appointments ogni 30 secondi per sincronizzazione real-time
    const refreshInterval = setInterval(() => {
      loadAppointments();
    }, 30000);
    
    return () => clearInterval(refreshInterval);
  }, [navigate]);

  // Effetto per ricerca pazienti lato server con debounce
  useEffect(() => {
    const searchTimeout = setTimeout(async () => {
      if (patientSearch && patientSearch.length >= 2) {
        const token = localStorage.getItem('token');
        try {
          const response = await axios.get(`${API}/admin/patients`, {
            params: { search: patientSearch, limit: 100 },
            headers: { Authorization: `Bearer ${token}` }
          });
          const results = response.data.patients || response.data || [];
          setPatients(results);
        } catch (error) {
          console.error('Errore ricerca pazienti:', error);
        }
      } else if (!patientSearch) {
        // Ricarica lista completa quando si cancella la ricerca
        loadData();
      }
    }, 300); // Debounce 300ms
    
    return () => clearTimeout(searchTimeout);
  }, [patientSearch]);

  const loadData = async () => {
    const token = localStorage.getItem('token');
    setLoading(true);
    try {
      const [statsRes, patientsRes, confirmRes, configRes, subscribersRes, appointmentsRes, doctorsRes, seoRes, videoConsultsRes] = await Promise.all([
        axios.get(`${API}/stats/admin`, { headers: { Authorization: `Bearer ${token}` } }),
        axios.get(`${API}/admin/patients`, { headers: { Authorization: `Bearer ${token}` } }).catch(() => ({ data: { patients: [] } })),
        axios.get(`${API}/admin/appointment-confirmations`, { headers: { Authorization: `Bearer ${token}` } }).catch(() => ({ data: { confirmations: [] } })),
        axios.get(`${API}/admin/config/status`, { headers: { Authorization: `Bearer ${token}` } }).catch(() => ({ data: null })),
        axios.get(`${API}/admin/newsletter/subscribers`, { headers: { Authorization: `Bearer ${token}` } }).catch(() => ({ data: { subscribers: [] } })),
        axios.get(`${API}/appointments`, { headers: { Authorization: `Bearer ${token}` } }).catch(() => ({ data: [] })),
        axios.get(`${API}/doctors`).catch(() => ({ data: { doctors: [] } })),
        axios.get(`${API}/seo/health`, { headers: { Authorization: `Bearer ${token}` } }).catch(() => ({ data: null })),
        axios.get(`${API}/videoconsult/list`, { headers: { Authorization: `Bearer ${token}` } }).catch(() => ({ data: { consultations: [] } }))
      ]);
      setStats(statsRes.data);
      setPatients(patientsRes.data.patients || patientsRes.data || []);
      setConfirmations(confirmRes.data.confirmations || []);
      setConfigStatus(configRes.data);
      setSubscribers(subscribersRes.data.subscribers || []);
      
      // Trasforma gli appuntamenti per compatibilità con il frontend
      const rawAppointments = appointmentsRes.data || [];
      const transformedAppointments = rawAppointments.map(apt => ({
        ...apt,
        date: apt.appointment_date ? apt.appointment_date.split('T')[0] : apt.date,
        time: apt.appointment_date ? apt.appointment_date.split('T')[1]?.substring(0, 5) : apt.time,
        is_videoconsult: false
      }));
      setAllAppointments(transformedAppointments);
      
      // Salva videoconsulti
      setAllVideoConsults(videoConsultsRes.data?.consultations || []);
      
      setDoctors(doctorsRes.data.doctors || []);
      setSeoData(seoRes.data);
      
      // Carica statistiche per sede
      try {
        const locRes = await axios.get(`${API}/stats/admin/by-location`, { headers: { Authorization: `Bearer ${token}` } });
        setLocationStats(locRes.data?.locations || null);
      } catch(e) { console.warn('Location stats not available'); }
    } catch (error) {
      console.error('Error loading data:', error);
    } finally {
      setLoading(false);
    }
  };

  const sendReminders = async () => {
    const token = localStorage.getItem('token');
    setSendingReminders(true);
    try {
      const response = await axios.post(`${API}/admin/send-reminders`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success(`Inviati ${response.data.reminders_sent} promemoria`);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Errore nell\'invio promemoria');
    } finally {
      setSendingReminders(false);
    }
  };

  // NEW: Carica dettagli statistiche per il modal
  const loadStatsDetail = async (type) => {
    const token = localStorage.getItem('token');
    setLoadingStatsDetail(true);
    try {
      const response = await axios.get(`${API}/stats/admin/detail/${type}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const titles = {
        'new_patients': 'Nuovi Pazienti Questo Mese',
        'returning_patients': 'Pazienti Tornati Questo Mese',
        'active_subscriptions': 'Abbonamenti Attivi',
        'scheduled_appointments': 'Appuntamenti Programmati',
        'completed_appointments': 'Appuntamenti Completati',
        'cancelled_appointments': 'Appuntamenti Cancellati',
        'top_services': 'Prestazioni Più Richieste',
        'patients_by_diagnosis': 'Pazienti per Diagnosi/Tag'
      };
      setStatsDetailModal({
        show: true,
        type,
        title: titles[type] || type,
        data: response.data.items || []
      });
    } catch (error) {
      console.error('Error loading stats detail:', error);
      toast.error('Errore nel caricamento dei dettagli');
    } finally {
      setLoadingStatsDetail(false);
    }
  };

  // Newsletter Scheduler functions
  const loadSchedulerStatus = async () => {
    const token = localStorage.getItem('token');
    setLoadingScheduler(true);
    try {
      const response = await axios.get(`${API}/newsletter-scheduler/status`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSchedulerStatus(response.data);
    } catch (error) {
      console.error('Error loading scheduler status:', error);
    } finally {
      setLoadingScheduler(false);
    }
  };

  const triggerNewsletterNow = async () => {
    const token = localStorage.getItem('token');
    setTriggeringScheduler(true);
    try {
      const response = await axios.post(`${API}/newsletter-scheduler/trigger-now`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Newsletter automatica inviata con successo!');
      loadSchedulerStatus();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Errore nell\'invio newsletter');
    } finally {
      setTriggeringScheduler(false);
    }
  };

  // Load scheduler status when newsletter tab is active
  useEffect(() => {
    if (activeTab === 'newsletter') {
      loadSchedulerStatus();
    }
  }, [activeTab]);

  // Sincronizza activeTab con i parametri URL quando cambiano
  useEffect(() => {
    const urlTab = searchParams.get('tab');
    if (urlTab && urlTab !== activeTab) {
      setActiveTab(urlTab);
    }
  }, [searchParams]);

  // Aggiorna URL quando cambia activeTab (solo se diverso)
  useEffect(() => {
    const urlTab = searchParams.get('tab');
    if (activeTab !== 'stats' && activeTab !== urlTab) {
      setSearchParams({ tab: activeTab });
    } else if (activeTab === 'stats' && urlTab) {
      setSearchParams({});
    }
  }, [activeTab]);

  // Load invoices when invoices tab is active
  useEffect(() => {
    if (activeTab === 'invoices') {
      loadInvoices(invoiceFilter);
    }
  }, [activeTab, invoiceFilter]);

  // Newsletter functions
  const generateNewsletterPreview = async (ageBracket) => {
    const token = localStorage.getItem('token');
    setGeneratingPreview(true);
    setSelectedAgeBracket(ageBracket);
    try {
      // First send a test to get preview
      const response = await axios.post(
        `${API}/smart-newsletters/send-by-age?age_bracket=${ageBracket}&send_test_only=true`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      // Get preview data
      const previewRes = await axios.get(`${API}/smart-newsletters/preview`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      const bracketData = previewRes.data.by_age_bracket[ageBracket] || { count: 0 };
      
      setNewsletterPreview({
        ageBracket,
        subject: response.data.template_subject,
        recipientsCount: bracketData.count,
        testSentTo: response.data.email,
        method: response.data.method
      });
      setNewsletterStep('preview');
      toast.success(`Anteprima inviata a ${response.data.email}`);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Errore generazione anteprima');
    } finally {
      setGeneratingPreview(false);
    }
  };

  const generateThematicPreview = async (theme) => {
    const token = localStorage.getItem('token');
    setGeneratingPreview(true);
    setSelectedTheme(theme);
    setNewsletterType('thematic');
    try {
      const response = await axios.post(
        `${API}/smart-newsletters/send-thematic?theme=${theme}&send_test_only=true`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      setNewsletterPreview({
        theme,
        subject: response.data.template_subject,
        recipientsCount: response.data.recipients_count,
        testSentTo: response.data.email,
        method: response.data.method
      });
      setNewsletterStep('preview');
      toast.success(`Anteprima inviata a ${response.data.email}`);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Errore generazione anteprima');
    } finally {
      setGeneratingPreview(false);
    }
  };

  const regenerateNewsletter = async () => {
    if (newsletterType === 'age' && selectedAgeBracket) {
      await generateNewsletterPreview(selectedAgeBracket);
    } else if (newsletterType === 'thematic' && selectedTheme) {
      await generateThematicPreview(selectedTheme);
    }
  };

  const confirmSendNewsletter = async () => {
    const token = localStorage.getItem('token');
    setSendingNewsletter(true);
    try {
      let response;
      if (newsletterType === 'age') {
        response = await axios.post(
          `${API}/smart-newsletters/send-by-age?age_bracket=${selectedAgeBracket}&send_test_only=false`,
          {},
          { headers: { Authorization: `Bearer ${token}` } }
        );
      } else {
        response = await axios.post(
          `${API}/smart-newsletters/send-thematic?theme=${selectedTheme}&send_test_only=false`,
          {},
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }
      toast.success(response.data.message);
      setNewsletterStep('select');
      setNewsletterPreview(null);
      setSelectedAgeBracket(null);
      setSelectedTheme(null);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Errore invio newsletter');
    } finally {
      setSendingNewsletter(false);
    }
  };

  const cancelNewsletter = () => {
    setNewsletterStep('select');
    setNewsletterPreview(null);
    setSelectedAgeBracket(null);
    setSelectedTheme(null);
    setNewsletterType('age');
  };

  // Aggiungi nuovo paziente
  const sendNewsletter = async () => {
    const token = localStorage.getItem('token');
    setSendingNewsletter(true);
    try {
      const response = await axios.post(`${API}/admin/newsletter/send-to-all`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success(response.data.message);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Errore nell\'invio newsletter');
    } finally {
      setSendingNewsletter(false);
    }
  };

  const createBackup = async () => {
    const token = localStorage.getItem('token');
    setCreatingBackup(true);
    try {
      const response = await axios.get(`${API}/admin/backup`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      // Download JSON file
      const blob = new Blob([JSON.stringify(response.data, null, 2)], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `primevision_backup_${new Date().toISOString().split('T')[0]}.json`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      
      toast.success(`Backup creato: ${response.data.total_patients} pazienti`);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Errore nella creazione backup');
    } finally {
      setCreatingBackup(false);
    }
  };

  const testEmail = async () => {
    const token = localStorage.getItem('token');
    try {
      const response = await axios.post(`${API}/admin/test-email`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success(response.data.message);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Errore test email');
    }
  };

  // Load doctors
  const loadDoctors = async () => {
    setLoadingDoctors(true);
    try {
      const response = await axios.get(`${API}/doctors`);
      setDoctors(response.data.doctors || []);
    } catch (error) {
      console.error('Error loading doctors:', error);
      toast.error('Errore nel caricamento dottori');
    } finally {
      setLoadingDoctors(false);
    }
  };

  // Load invoices
  const loadInvoices = async (type = 'all') => {
    const token = localStorage.getItem('token');
    setLoadingInvoices(true);
    try {
      let url = `${API}/admin/invoices`;
      if (type !== 'all') {
        url = `${API}/admin/invoices/${type === 'patient' ? 'patients' : 'staff'}`;
      }
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setInvoices(response.data.invoices || []);
      if (response.data.stats) {
        setInvoiceStats(response.data.stats);
      }
    } catch (error) {
      console.error('Error loading invoices:', error);
      toast.error('Errore nel caricamento fatture');
    } finally {
      setLoadingInvoices(false);
    }
  };

  // Load all appointments and videoconsults
  const loadAppointments = async () => {
    const token = localStorage.getItem('token');
    setLoadingAppointments(true);
    try {
      // Carica appuntamenti e videoconsulti in parallelo
      const [appointmentsRes, videoConsultsRes] = await Promise.all([
        axios.get(`${API}/appointments`, {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(`${API}/videoconsult/list`, {
          headers: { Authorization: `Bearer ${token}` }
        }).catch(() => ({ data: { consultations: [] } }))
      ]);
      
      // Trasforma gli appuntamenti per compatibilità con il frontend
      const rawAppointments = appointmentsRes.data || [];
      const transformedAppointments = rawAppointments.map(apt => ({
        ...apt,
        date: apt.appointment_date ? apt.appointment_date.split('T')[0] : apt.date,
        time: apt.appointment_date ? apt.appointment_date.split('T')[1]?.substring(0, 5) : apt.time,
        is_videoconsult: false
      }));
      setAllAppointments(transformedAppointments);
      
      // Salva videoconsulti separatamente
      const consultations = videoConsultsRes.data?.consultations || [];
      setAllVideoConsults(consultations);
    } catch (error) {
      console.error('Error loading appointments:', error);
      toast.error('Errore nel caricamento appuntamenti');
    } finally {
      setLoadingAppointments(false);
    }
  };

  // Filter appointments by selected date (include videoconsults)
  const filteredAppointments = [...allAppointments.filter(apt => {
    let match = apt.date === selectedDate;
    if (appointmentFilters.doctor) {
      match = match && apt.doctor_id === appointmentFilters.doctor;
    }
    if (appointmentFilters.status) {
      match = match && apt.status === appointmentFilters.status;
    }
    if (appointmentFilters.room) {
      const doctor = doctors.find(d => d.id === apt.doctor_id);
      match = match && doctor?.room === appointmentFilters.room;
    }
    if (locationFilter) {
      match = match && apt.location === locationFilter;
    }
    return match;
  }), 
  // Aggiungi videoconsulti confermati come "appuntamenti virtuali"
  ...allVideoConsults.filter(vc => {
    if (!vc.scheduled_at) return false;
    const vcDate = vc.scheduled_at.split('T')[0];
    let match = vcDate === selectedDate && ['confirmed', 'in_progress'].includes(vc.status);
    if (appointmentFilters.doctor) {
      match = match && vc.doctor_id === appointmentFilters.doctor;
    }
    return match;
  }).map(vc => ({
    ...vc,
    date: vc.scheduled_at?.split('T')[0],
    time: vc.scheduled_at?.split('T')[1]?.substring(0, 5) || '00:00',
    service: '📹 Videoconsulto',
    is_videoconsult: true,
    patient_name: vc.patient_name || 'N/A',
    doctor_name: vc.doctor_name || 'N/A'
  }))
  ].sort((a, b) => (a.time || '00:00').localeCompare(b.time || '00:00'));

  // Get appointments count per day for calendar (include videoconsults)
  const getAppointmentsForDay = (dateStr) => {
    const appointments = allAppointments.filter(apt => apt.date === dateStr).length;
    const videoConsults = allVideoConsults.filter(vc => {
      if (!vc.scheduled_at) return false;
      return vc.scheduled_at.split('T')[0] === dateStr && ['confirmed', 'in_progress'].includes(vc.status);
    }).length;
    return appointments + videoConsults;
  };

  // Open edit modal
  const openEditAppointment = (appointment) => {
    setEditAppointmentModal({
      show: true,
      appointment: { ...appointment },
      newDate: appointment.date,
      newTime: appointment.time,
      newDoctorId: appointment.doctor_id,
      newStatus: appointment.status
    });
  };

  // Load available slots for doctor on date
  const loadAvailableSlots = async (doctorId, date) => {
    if (!doctorId || !date) {
      setAvailableSlots([]);
      return;
    }
    
    const token = localStorage.getItem('token');
    setLoadingSlots(true);
    
    try {
      const response = await axios.get(`${API}/doctors/available-slots`, {
        params: { doctor_id: doctorId, date },
        headers: { Authorization: `Bearer ${token}` }
      });
      
      if (response.data.available && response.data.slots) {
        setAvailableSlots(response.data.slots);
      } else {
        setAvailableSlots([]);
        if (!response.data.available) {
          toast.info('Il medico non è disponibile in questa data');
        }
      }
    } catch (error) {
      console.error('Error loading slots:', error);
      setAvailableSlots([]);
    } finally {
      setLoadingSlots(false);
    }
  };

  // Search patients
  const searchPatients = async (query) => {
    if (!query || query.length < 2) {
      setPatientSearchResults([]);
      return;
    }
    
    const token = localStorage.getItem('token');
    setSearchingPatients(true);
    
    try {
      const response = await axios.get(`${API}/admin/patients`, {
        params: { search: query },
        headers: { Authorization: `Bearer ${token}` }
      });
      // API returns list directly, not wrapped in "patients" key
      const patients = Array.isArray(response.data) ? response.data : (response.data.patients || []);
      setPatientSearchResults(patients.slice(0, 10));
    } catch (error) {
      console.error('Error searching patients:', error);
      setPatientSearchResults([]);
    } finally {
      setSearchingPatients(false);
    }
  };

  // Create new appointment by admin
  const createNewAppointment = async () => {
    const token = localStorage.getItem('token');
    const { appointment, newDate, newTime, newDoctorId, selectedPatient, newLocation } = editAppointmentModal;
    
    if (!selectedPatient?.id || !newDoctorId || !newDate || !newTime) {
      toast.error('Compila tutti i campi obbligatori');
      return;
    }
    
    setSavingAppointment(true);
    
    try {
      await axios.post(`${API}/appointments/create-by-admin`, {
        patient_id: selectedPatient.id,
        doctor_id: newDoctorId,
        date: newDate,
        time_slot: newTime,
        reason: appointment?.reason || 'Visita',
        notes: appointment?.notes || '',
        location: newLocation || null
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      toast.success('Appuntamento creato con successo!');
      setEditAppointmentModal({ show: false, appointment: null });
      setAvailableSlots([]);
      setPatientSearchQuery('');
      setPatientSearchResults([]);
      loadAppointments();
    } catch (error) {
      console.error('Error creating appointment:', error);
      toast.error(error.response?.data?.detail || 'Errore nella creazione');
    } finally {
      setSavingAppointment(false);
    }
  };

  // Save appointment changes
  const saveAppointmentChanges = async () => {
    const token = localStorage.getItem('token');
    setSavingAppointment(true);
    
    try {
      const { appointment, newDate, newTime, newDoctorId, newStatus } = editAppointmentModal;
      
      // Update date/time if changed
      if (newDate !== appointment.date || newTime !== appointment.time) {
        await axios.patch(`${API}/appointments/${appointment.id}/reschedule`, 
          { new_date: newDate, new_time: newTime },
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }
      
      // Update status if changed
      if (newStatus !== appointment.status) {
        await axios.patch(`${API}/appointments/${appointment.id}/status`,
          { status: newStatus },
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }
      
      // Update doctor if changed (need to add this endpoint)
      if (newDoctorId !== appointment.doctor_id) {
        await axios.patch(`${API}/appointments/${appointment.id}/reassign`,
          { new_doctor_id: newDoctorId },
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }
      
      toast.success('Appuntamento aggiornato!');
      setEditAppointmentModal({ show: false, appointment: null });
      loadAppointments();
    } catch (error) {
      console.error('Error updating appointment:', error);
      toast.error(error.response?.data?.detail || 'Errore nell\'aggiornamento');
    } finally {
      setSavingAppointment(false);
    }
  };

  // Delete/Cancel appointment
  const cancelAppointment = async (appointmentId) => {
    const token = localStorage.getItem('token');
    if (!window.confirm('Sei sicuro di voler cancellare questo appuntamento?')) return;
    
    try {
      await axios.delete(`${API}/appointments/${appointmentId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Appuntamento cancellato');
      loadAppointments();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Errore nella cancellazione');
    }
  };

  // Generate calendar days
  const generateCalendarDays = () => {
    const year = calendarMonth.getFullYear();
    const month = calendarMonth.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const startPadding = firstDay.getDay() === 0 ? 6 : firstDay.getDay() - 1; // Monday start
    
    const days = [];
    
    // Previous month padding
    for (let i = startPadding - 1; i >= 0; i--) {
      const d = new Date(year, month, -i);
      days.push({ date: d, isCurrentMonth: false });
    }
    
    // Current month
    for (let i = 1; i <= lastDay.getDate(); i++) {
      days.push({ date: new Date(year, month, i), isCurrentMonth: true });
    }
    
    // Next month padding
    const remaining = 42 - days.length;
    for (let i = 1; i <= remaining; i++) {
      days.push({ date: new Date(year, month + 1, i), isCurrentMonth: false });
    }
    
    return days;
  };

  // Update invoice status
  const updateInvoiceStatus = async (invoiceId, newStatus) => {
    const token = localStorage.getItem('token');
    try {
      await axios.put(`${API}/admin/invoices/${invoiceId}`, 
        { status: newStatus },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success('Fattura aggiornata');
      loadInvoices(invoiceFilter);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Errore aggiornamento');
    }
  };

  // Create new invoice
  const createInvoice = async () => {
    if (!newInvoice.patient_id || !newInvoice.amount) {
      toast.error('Seleziona un paziente e inserisci un importo');
      return;
    }
    
    const token = localStorage.getItem('token');
    try {
      await axios.post(`${API}/invoices`, {
        patient_id: newInvoice.patient_id,
        invoice_type: 'patient',
        description: newInvoice.description || 'Prestazione sanitaria',
        items: newInvoice.items,
        amount: newInvoice.amount,
        status: 'pending'
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      toast.success('Fattura creata con successo');
      setShowCreateInvoiceModal(false);
      setNewInvoice({
        patient_id: '',
        patient_name: '',
        description: '',
        items: [{ description: 'Visita oculistica', amount: 100 }],
        amount: 100
      });
      loadInvoices(invoiceFilter);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Errore creazione fattura');
    }
  };

  // Update doctor room
  const updateDoctorRoom = async (doctorId, newRoom) => {
    const token = localStorage.getItem('token');
    setSavingDoctor(doctorId);
    try {
      await axios.put(`${API}/admin/doctors/${doctorId}`, 
        { room: newRoom },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      // Update local state
      setDoctors(prev => prev.map(d => 
        d.id === doctorId ? { ...d, room: newRoom } : d
      ));
      
      toast.success('Stanza aggiornata');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Errore nell\'aggiornamento');
    } finally {
      setSavingDoctor(null);
    }
  };

  // Update doctor specialization
  const updateDoctorSpecialization = async (doctorId, newSpec) => {
    const token = localStorage.getItem('token');
    setSavingDoctor(doctorId);
    try {
      await axios.put(`${API}/admin/doctors/${doctorId}`, 
        { specialization: newSpec },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setDoctors(prev => prev.map(d => 
        d.id === doctorId ? { ...d, specialization: newSpec } : d
      ));
      toast.success('Specializzazione aggiornata');
    } catch (error) {
      toast.error('Errore aggiornamento');
    } finally {
      setSavingDoctor(null);
    }
  };

  // Create new doctor
  const handleCreateDoctor = async () => {
    if (!newDoctorForm.first_name || !newDoctorForm.last_name || !newDoctorForm.email || !newDoctorForm.password) {
      toast.error('Compila tutti i campi obbligatori');
      return;
    }
    
    setAddingDoctor(true);
    const token = localStorage.getItem('token');
    
    try {
      const response = await axios.post(`${API}/admin/doctors`, newDoctorForm, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const tipoLabel = newDoctorForm.staff_type === 'ortottista' ? 'Ortottista' : 'Oculista';
      toast.success(`${tipoLabel} creato con successo!`);
      setShowAddDoctorModal(false);
      setNewDoctorForm({ first_name: '', last_name: '', email: '', password: '', phone: '', specialization: '', staff_type: 'doctor', work_locations: ['milano', 'napoli'] });
      loadDoctors();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Errore nella creazione');
    } finally {
      setAddingDoctor(false);
    }
  };

  // Delete doctor
  const handleDeleteDoctor = async (doctorId, doctorName, staffType) => {
    const tipoLabel = staffType === 'ortottista' ? 'Ortottista' : 'Dott.';
    if (!window.confirm(`Sei sicuro di voler eliminare ${tipoLabel} ${doctorName}?`)) {
      return;
    }
    
    setDeletingDoctor(doctorId);
    const token = localStorage.getItem('token');
    
    try {
      await axios.delete(`${API}/admin/doctors/${doctorId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Staff medico eliminato con successo');
      loadDoctors();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Errore nell\'eliminazione');
    } finally {
      setDeletingDoctor(null);
    }
  };

  // Load doctors when tab changes
  useEffect(() => {
    if (activeTab === 'doctors') {
      loadDoctors();
    }
  }, [activeTab]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/');
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(amount);
  };

  const getGrowthColor = (current, previous) => {
    if (current > previous) return '#10B981';
    if (current < previous) return '#EF4444';
    return '#6B7280';
  };

  return (
    <div className="min-h-screen flex flex-col lg:flex-row" style={{background: '#F9FAFB'}}>
      {/* Mobile Header with Hamburger */}
      <div className="lg:hidden flex items-center justify-between p-4 bg-gradient-to-br from-[#e8f4fd] via-[#f4f9fe] to-[#dcedf8] border-b border-[#2A9FCB]/20">
        <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity">
          <img src="/logo-primevision-small.png" alt="PRIME VISION" className="w-10 h-10 object-contain" />
          <p className="text-xs" style={{color: '#6B7280'}}>Area Amministrativa</p>
        </Link>
        <button 
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="p-2 rounded-lg hover:bg-white/50 transition-all"
          style={{color: '#2A9FCB'}}
        >
          {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile Menu Overlay */}
      {mobileMenuOpen && (
        <div className="lg:hidden fixed inset-0 z-50 bg-black/50" onClick={() => setMobileMenuOpen(false)}>
          <div 
            className="absolute top-0 right-0 w-72 h-full bg-gradient-to-br from-[#e8f4fd] via-[#f4f9fe] to-[#dcedf8] p-6 overflow-y-auto shadow-xl animate-slide-in-right"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between mb-6">
              <Link to="/" className="flex items-center gap-2 hover:opacity-80 transition-opacity">
                <img src="/logo-primevision-small.png" alt="PRIME VISION" className="w-8 h-8 object-contain" />
                <p className="text-xs" style={{color: '#6B7280'}}>Area Amministrativa</p>
              </Link>
              <button 
                onClick={() => setMobileMenuOpen(false)}
                className="p-2 rounded-lg hover:bg-white/50"
                style={{color: '#2A9FCB'}}
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            {/* SALA D'ATTESA - Pulsante prominente MOBILE */}
            <button
              onClick={() => { navigate('/waiting-room'); setMobileMenuOpen(false); }}
              className="w-full flex items-center justify-center gap-3 px-4 py-4 mb-4 rounded-xl bg-gradient-to-r from-[#2A9FCB] to-[#1E88B5] text-white font-semibold shadow-lg hover:shadow-xl transition-all"
              data-testid="btn-waiting-room-mobile"
            >
              <QrCode className="w-6 h-6" />
              <span className="text-lg">Sala d'Attesa</span>
            </button>

            <nav className="space-y-2">
              {[
                { id: 'stats', icon: BarChart3, label: 'Statistiche' },
                { id: 'appointments', icon: Calendar, label: 'Appuntamenti' },
                { id: 'patients', icon: Users, label: 'Pazienti' },
                { id: 'checkin', icon: QrCode, label: 'Check-in' },
                { id: 'content-planner', icon: Calendar, label: 'Piano Contenuti' },
                { id: 'video-series', icon: Film, label: 'Gli Occhi Parlanti' },
                { id: 'subscriptions', icon: CreditCard, label: 'Abbonamenti' },
                { id: 'ml-analytics', icon: Brain, label: 'ML Analytics' },
                { id: 'database', icon: Database, label: 'Database' },
                { id: 'config', icon: Settings, label: 'Configurazioni' },
                { id: 'staff', icon: Stethoscope, label: 'Staff Medico' },
                { id: 'manual', icon: BookOpen, label: 'Manuale Operativo' },
              ].map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => { setActiveTab(tab.id); setMobileMenuOpen(false); }}
                  className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-all ${activeTab === tab.id ? 'bg-white shadow-sm' : 'hover:bg-white/50'}`}
                  style={{color: '#2A9FCB'}}
                >
                  <tab.icon className="w-5 h-5" />
                  <span>{tab.label}</span>
                </button>
              ))}
            </nav>

            <div className="border-t border-[#2A9FCB]/20 mt-4 pt-4 space-y-1">
              <button onClick={() => { navigate('/'); setMobileMenuOpen(false); }} className="w-full flex items-center space-x-3 px-4 py-2 rounded-lg hover:bg-white/50 text-sm" style={{color: '#6B7280'}}>
                <ExternalLink className="w-4 h-4" /><span>Home</span>
              </button>
              <button onClick={() => { navigate('/tests'); setMobileMenuOpen(false); }} className="w-full flex items-center space-x-3 px-4 py-2 rounded-lg hover:bg-white/50 text-sm" style={{color: '#6B7280'}}>
                <Eye className="w-4 h-4" /><span>Test Visivi</span>
              </button>
            </div>

            <button onClick={() => { handleLogout(); setMobileMenuOpen(false); }} className="w-full flex items-center space-x-3 px-4 py-3 rounded-lg mt-4 hover:bg-red-50" style={{color: '#EF4444'}}>
              <LogOut className="w-5 h-5" /><span>Esci</span>
            </button>
          </div>
        </div>
      )}

      {/* Desktop Sidebar - Hidden on mobile */}
      <div className="hidden lg:block w-64 p-6 flex-shrink-0" style={{background: 'linear-gradient(135deg, #daeef9 0%, #f0f7fc 50%, #d4e8f5 100%)'}}>
        <Link to="/" className="flex items-center gap-3 mb-6 hover:opacity-80 transition-opacity">
          <img src="/logo-primevision-small.png" alt="PRIME VISION" className="w-12 h-12 object-contain" />
          <p className="text-sm" style={{color: '#6B7280'}}>Area Amministrativa</p>
        </Link>

        {/* SALA D'ATTESA - Pulsante prominente */}
        <button
          onClick={() => navigate('/waiting-room')}
          className="w-full flex items-center justify-center gap-3 px-4 py-4 mb-6 rounded-xl bg-gradient-to-r from-[#2A9FCB] to-[#1E88B5] text-white font-semibold shadow-lg hover:shadow-xl transition-all transform hover:scale-[1.02]"
          data-testid="btn-waiting-room"
        >
          <QrCode className="w-6 h-6" />
          <span className="text-lg">Sala d'Attesa</span>
        </button>

        <nav className="space-y-2">
          <button
            onClick={() => setActiveTab('stats')}
            className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-all ${activeTab === 'stats' ? 'bg-white shadow-sm' : 'hover:bg-white/50'}`}
            style={{color: '#2A9FCB'}}
            data-testid="tab-stats"
          >
            <BarChart3 className="w-5 h-5" />
            <span>Statistiche</span>
          </button>
          <button
            onClick={() => setActiveTab('checkin')}
            className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-all ${activeTab === 'checkin' ? 'bg-white shadow-sm font-semibold' : 'hover:bg-white/50'}`}
            style={{color: '#2A9FCB'}}
            data-testid="tab-checkin"
          >
            <QrCode className="w-5 h-5" />
            <span>Check-in</span>
          </button>
          <button
            onClick={() => setActiveTab('appointments')}
            className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-all ${activeTab === 'appointments' ? 'bg-white shadow-sm font-semibold' : 'hover:bg-white/50'}`}
            style={{color: '#2A9FCB'}}
            data-testid="tab-appointments"
          >
            <Calendar className="w-5 h-5" />
            <span>Appuntamenti</span>
          </button>
          <button
            onClick={() => setActiveTab('patients')}
            className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-all ${activeTab === 'patients' ? 'bg-white shadow-sm' : 'hover:bg-white/50'}`}
            style={{color: '#2A9FCB'}}
            data-testid="tab-patients"
          >
            <Users className="w-5 h-5" />
            <span>Pazienti</span>
          </button>
          <button
            onClick={() => setActiveTab('subscriptions')}
            className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-all ${activeTab === 'subscriptions' ? 'bg-white shadow-sm' : 'hover:bg-white/50'}`}
            style={{color: '#2A9FCB'}}
            data-testid="tab-subscriptions"
          >
            <CreditCard className="w-5 h-5" />
            <span>Abbonamenti</span>
          </button>
          <button
            onClick={() => setActiveTab('ml-analytics')}
            className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-all ${activeTab === 'ml-analytics' ? 'bg-white shadow-sm' : 'hover:bg-white/50'}`}
            style={{color: '#2A9FCB'}}
            data-testid="tab-ml-analytics"
          >
            <Brain className="w-5 h-5" />
            <span>ML Analytics</span>
          </button>
          <button
            onClick={() => setActiveTab('newsletter')}
            className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-all ${activeTab === 'newsletter' ? 'bg-white shadow-sm font-semibold' : 'hover:bg-white/50'}`}
            style={{color: '#2A9FCB'}}
            data-testid="tab-newsletter"
          >
            <Mail className="w-5 h-5" />
            <span>Newsletter</span>
          </button>
          <button
            onClick={() => setActiveTab('content-planner')}
            className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-all ${activeTab === 'content-planner' ? 'bg-white shadow-sm font-semibold' : 'hover:bg-white/50'}`}
            style={{color: '#2A9FCB'}}
            data-testid="tab-content-planner"
          >
            <Calendar className="w-5 h-5" />
            <span>Piano Contenuti</span>
          </button>
          <button
            onClick={() => setActiveTab('video-series')}
            className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-all ${activeTab === 'video-series' ? 'bg-white shadow-sm font-semibold' : 'hover:bg-white/50'}`}
            style={{color: '#2A9FCB'}}
            data-testid="tab-video-series"
          >
            <Film className="w-5 h-5" />
            <span>Gli Occhi Parlanti</span>
          </button>
          <button
            onClick={() => setActiveTab('database')}
            className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-all ${activeTab === 'database' ? 'bg-white shadow-sm' : 'hover:bg-white/50'}`}
            style={{color: '#2A9FCB'}}
            data-testid="tab-database"
          >
            <Database className="w-5 h-5" />
            <span>Database</span>
          </button>
          <button
            onClick={() => setActiveTab('config')}
            className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-all ${activeTab === 'config' ? 'bg-white shadow-sm' : 'hover:bg-white/50'}`}
            style={{color: '#2A9FCB'}}
            data-testid="tab-config"
          >
            <Settings className="w-5 h-5" />
            <span>Configurazione</span>
          </button>
          <button
            onClick={() => setActiveTab('doctors')}
            className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-all ${activeTab === 'doctors' ? 'bg-white shadow-sm' : 'hover:bg-white/50'}`}
            style={{color: '#2A9FCB'}}
            data-testid="tab-doctors"
          >
            <Stethoscope className="w-5 h-5" />
            <span>Staff Medico</span>
          </button>
          <button
            onClick={() => setActiveTab('protocols')}
            className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-all ${activeTab === 'protocols' ? 'bg-white shadow-sm' : 'hover:bg-white/50'}`}
            style={{color: '#2A9FCB'}}
            data-testid="tab-protocols"
          >
            <Shield className="w-5 h-5" />
            <span>Protocolli</span>
          </button>
          <button
            onClick={() => setActiveTab('invoices')}
            className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-all ${activeTab === 'invoices' ? 'bg-white shadow-sm' : 'hover:bg-white/50'}`}
            style={{color: '#2A9FCB'}}
            data-testid="tab-invoices"
          >
            <FileText className="w-5 h-5" />
            <span>Fatture</span>
          </button>
          
          {/* HR/ERP Section */}
          <div className="mt-4 pt-4 border-t border-gray-200">
            <p className="text-xs text-[#2A9FCB]/60 mb-3 px-2">GESTIONE HR/ERP</p>
            <button
              onClick={() => setActiveTab('inventory')}
              className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-all ${activeTab === 'inventory' ? 'bg-white shadow-sm' : 'hover:bg-white/50'}`}
              style={{color: '#2A9FCB'}}
              data-testid="tab-inventory"
            >
              <Package className="w-5 h-5" />
              <span>Magazzino Farmaci</span>
            </button>
            <button
              onClick={() => setActiveTab('shifts')}
              className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-all ${activeTab === 'shifts' ? 'bg-white shadow-sm' : 'hover:bg-white/50'}`}
              style={{color: '#2A9FCB'}}
              data-testid="tab-shifts"
            >
              <Clock className="w-5 h-5" />
              <span>Gestione Turni</span>
            </button>
            <button
              onClick={() => setActiveTab('hr-reports')}
              className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-all ${activeTab === 'hr-reports' ? 'bg-white shadow-sm' : 'hover:bg-white/50'}`}
              style={{color: '#2A9FCB'}}
              data-testid="tab-hr-reports"
            >
              <BarChart3 className="w-5 h-5" />
              <span>Reportistica HR</span>
            </button>
            <button
              onClick={() => setActiveTab('payroll')}
              className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-all ${activeTab === 'payroll' ? 'bg-white shadow-sm' : 'hover:bg-white/50'}`}
              style={{color: '#2A9FCB'}}
              data-testid="tab-payroll"
            >
              <DollarSign className="w-5 h-5" />
              <span>Cedolini e Stipendi</span>
            </button>
          </div>
          
          <button
            onClick={() => setActiveTab('manuale')}
            className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-all ${activeTab === 'manuale' ? 'bg-white shadow-sm' : 'hover:bg-white/50'}`}
            style={{color: '#2A9FCB'}}
            data-testid="tab-manual"
          >
            <BookOpen className="w-5 h-5" />
            <span>Manuale Operativo</span>
          </button>
          <button
            onClick={() => setActiveTab('reviews')}
            className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-all ${activeTab === 'reviews' ? 'bg-white shadow-sm' : 'hover:bg-white/50'}`}
            style={{color: '#2A9FCB'}}
            data-testid="tab-reviews"
          >
            <Star className="w-5 h-5" />
            <span>La Mia Recensione</span>
          </button>
        </nav>

        {/* Link Navigazione Sito */}
        <div className="mt-6 pt-4 border-t border-gray-200">
          <p className="text-xs text-[#2A9FCB]/60 mb-3 px-2">NAVIGAZIONE SITO</p>
          <button 
            onClick={() => navigate('/')} 
            className="w-full flex items-center space-x-3 px-4 py-2 rounded-lg hover:bg-white/50 transition-all text-sm"
            style={{color: '#6B7280'}}
          >
            <ExternalLink className="w-4 h-4" />
            <span>Home</span>
          </button>
          <button 
            onClick={() => navigate('/tests')} 
            className="w-full flex items-center space-x-3 px-4 py-2 rounded-lg hover:bg-white/50 transition-all text-sm"
            style={{color: '#6B7280'}}
          >
            <Eye className="w-4 h-4" />
            <span>Test Visivi</span>
          </button>
          <button 
            onClick={() => navigate('/linee-guida')} 
            className="w-full flex items-center space-x-3 px-4 py-2 rounded-lg hover:bg-white/50 transition-all text-sm"
            style={{color: '#6B7280'}}
          >
            <FileText className="w-4 h-4" />
            <span>Linee Guida</span>
          </button>
          <button 
            onClick={() => navigate('/manualistica')} 
            className="w-full flex items-center space-x-3 px-4 py-2 rounded-lg hover:bg-amber-50 transition-all text-sm font-medium"
            style={{color: '#B45309'}}
          >
            <BookOpen className="w-4 h-4" />
            <span>Manualistica</span>
          </button>
        </div>

        <button onClick={handleLogout} className="w-full flex items-center space-x-3 px-4 py-3 rounded-lg mt-4 hover:bg-red-50 transition-all" style={{color: '#EF4444'}} data-testid="logout-btn">
          <LogOut className="w-5 h-5" />
          <span>Esci</span>
        </button>
      </div>

      {/* Main Content */}
      <div className="flex-1 p-4 lg:p-8 overflow-y-auto">
        <div className="max-w-7xl mx-auto">
          {/* Breadcrumb Navigation */}
          <Breadcrumb 
            items={[
              { label: 'Home', path: '/' },
              { label: 'Dashboard Admin', path: '/admin' }
            ]}
            currentPage={
              activeTab === 'stats' ? 'Statistiche' :
              activeTab === 'appointments' ? 'Appuntamenti' :
              activeTab === 'patients' ? 'Pazienti' :
              activeTab === 'subscriptions' ? 'Abbonamenti' :
              activeTab === 'newsletter' ? 'Newsletter' :
              activeTab === 'content-planner' ? 'Piano Contenuti' :
              activeTab === 'video-series' ? 'Gli Occhi Parlanti' :
              activeTab === 'social' ? 'Social Media' :
              activeTab === 'ml-analytics' ? 'ML Analytics' :
              activeTab === 'database' ? 'Database' :
              activeTab === 'config' ? 'Configurazioni' :
              activeTab === 'staff' ? 'Staff Medico' :
              activeTab === 'manual' ? 'Manuale Operativo' :
              activeTab === 'messages' ? 'Messaggi' : null
            }
          />
          
          <div className="flex justify-between items-center mb-8">
            <div>
              <h1 className="text-2xl lg:text-3xl font-bold" style={{color: '#2c4667'}}>
                Dashboard Amministrativa
              </h1>
              <p className="text-[#2c4667]/70 text-sm lg:text-base">Benvenuta, {user?.first_name}</p>
            </div>
            <div className="flex items-center gap-2 lg:gap-3">
              <NotificationBell userId={user?.id} />
              <MessageBell userId={user?.id} iconColor="#2A9FCB" currentUser={user} />
              <button 
                onClick={loadData}
                className="hidden sm:flex items-center gap-2 px-4 py-2 rounded-lg transition-all hover:bg-white"
                style={{color: '#2A9FCB', border: '1px solid #E5E7EB'}}
              >
                <RefreshCcw className={`w-4 h-4 ${loading ? 'animate-spin' : ''}`} />
                Aggiorna
              </button>
            </div>
          </div>

          {loading && !stats ? (
            <div className="flex justify-center py-20">
              <div className="w-12 h-12 border-4 border-t-transparent rounded-full animate-spin" style={{borderColor: '#2A9FCB'}}></div>
            </div>
          ) : (
            <>
              {/* Statistics Tab */}
              {activeTab === 'stats' && stats && (
                <div className="space-y-6">
                  {/* Main KPIs - CLICKABLE */}
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {/* Total Patients - CLICKABLE */}
                    <button 
                      onClick={() => setActiveTab('patients')}
                      className="rounded-2xl p-6 shadow-lg bg-gradient-to-br from-[#2c4667] to-[#3d5a80] hover:shadow-xl hover:scale-[1.02] transition-all text-left"
                    >
                      <div className="flex items-center justify-between mb-4">
                        <div className="w-12 h-12 rounded-xl bg-white/20 flex items-center justify-center">
                          <Users className="w-6 h-6 text-white" />
                        </div>
                        <ChevronRight className="w-5 h-5 text-white/70" />
                      </div>
                      <p className="text-4xl font-bold text-white">{stats.patients.total}</p>
                      <p className="text-sm text-white/90 font-medium">Pazienti totali</p>
                      <p className="text-xs text-white/70 mt-1">Clicca per vedere la lista →</p>
                    </button>

                    {/* New Patients - CLICKABLE */}
                    <button 
                      onClick={() => loadStatsDetail('new_patients')}
                      className="rounded-2xl p-6 shadow-lg bg-white border-2 border-emerald-100 hover:border-emerald-300 hover:shadow-xl transition-all text-left group"
                    >
                      <div className="flex items-center justify-between mb-4">
                        <div className="w-12 h-12 rounded-xl bg-emerald-100 flex items-center justify-center group-hover:bg-emerald-200 transition-colors">
                          <UserPlus className="w-6 h-6 text-emerald-600" />
                        </div>
                        <div className="flex items-center gap-1 text-xs px-3 py-1.5 rounded-full font-medium" style={{
                          background: stats.patients.new_this_month >= stats.patients.new_last_month ? '#D1FAE5' : '#FEE2E2',
                          color: stats.patients.new_this_month >= stats.patients.new_last_month ? '#065F46' : '#991B1B'
                        }}>
                          {stats.patients.new_this_month >= stats.patients.new_last_month ? '↑' : '↓'} 
                          vs scorso
                        </div>
                      </div>
                      <p className="text-4xl font-bold text-emerald-600">{stats.patients.new_this_month}</p>
                      <p className="text-sm text-gray-600 font-medium">Nuovi questo mese</p>
                      <p className="text-xs text-gray-400 mt-1">Clicca per vedere chi sono →</p>
                    </button>

                    {/* Returning Patients - CLICKABLE */}
                    <button 
                      onClick={() => loadStatsDetail('returning_patients')}
                      className="rounded-2xl p-6 shadow-lg bg-white border-2 border-blue-100 hover:border-blue-300 hover:shadow-xl transition-all text-left group"
                    >
                      <div className="flex items-center justify-between mb-4">
                        <div className="w-12 h-12 rounded-xl bg-blue-100 flex items-center justify-center group-hover:bg-blue-200 transition-colors">
                          <RefreshCcw className="w-6 h-6 text-blue-600" />
                        </div>
                        <span className="text-xs px-3 py-1.5 rounded-full font-medium bg-blue-100 text-blue-700">Fidelizzati</span>
                      </div>
                      <p className="text-4xl font-bold text-blue-600">{stats.patients.returning_this_month}</p>
                      <p className="text-sm text-gray-600 font-medium">Tornati questo mese</p>
                      <p className="text-xs text-gray-400 mt-1">Clicca per vedere chi sono →</p>
                    </button>

                    {/* Active Subscriptions - CLICKABLE */}
                    <button 
                      onClick={() => loadStatsDetail('active_subscriptions')}
                      className="rounded-2xl p-6 shadow-lg bg-white border-2 border-amber-100 hover:border-amber-300 hover:shadow-xl transition-all text-left group"
                    >
                      <div className="flex items-center justify-between mb-4">
                        <div className="w-12 h-12 rounded-xl bg-amber-100 flex items-center justify-center group-hover:bg-amber-200 transition-colors">
                          <CreditCard className="w-6 h-6 text-amber-600" />
                        </div>
                        <span className="text-xs px-3 py-1.5 rounded-full font-medium bg-amber-100 text-amber-700">Abbonati</span>
                      </div>
                      <p className="text-4xl font-bold text-amber-600">{stats.subscriptions.active}</p>
                      <p className="text-sm text-gray-600 font-medium">Abbonamenti attivi</p>
                      <p className="text-xs text-gray-400 mt-1">+{stats.subscriptions.new_this_month} nuovi • Clicca →</p>
                    </button>
                  </div>

                  {/* Patient Activity Tags Overview */}
                  <div className="rounded-2xl p-6 shadow-lg bg-white border border-gray-200">
                    <h3 className="text-lg font-bold mb-4 flex items-center gap-2 text-gray-800">
                      <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-purple-500 to-indigo-600 flex items-center justify-center">
                        <Tag className="w-5 h-5 text-white" />
                      </div>
                      Segmentazione Pazienti
                    </h3>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                      <button 
                        onClick={() => loadStatsDetail('patients_lead')}
                        className="p-4 rounded-xl bg-gradient-to-br from-red-50 to-red-100 border-2 border-red-200 hover:border-red-400 hover:shadow-md transition-all text-left"
                      >
                        <div className="flex items-center gap-2 mb-2">
                          <span className="text-lg">🎯</span>
                          <span className="text-xs font-bold text-red-700 uppercase">Lead</span>
                        </div>
                        <p className="text-2xl font-bold text-red-600">{stats.patient_tags?.LEAD || 0}</p>
                        <p className="text-xs text-red-600/70">0 visite - Da convertire</p>
                      </button>
                      
                      <button 
                        onClick={() => loadStatsDetail('patients_naive')}
                        className="p-4 rounded-xl bg-gradient-to-br from-yellow-50 to-amber-100 border-2 border-yellow-200 hover:border-yellow-400 hover:shadow-md transition-all text-left"
                      >
                        <div className="flex items-center gap-2 mb-2">
                          <span className="text-lg">🌱</span>
                          <span className="text-xs font-bold text-yellow-700 uppercase">Naive</span>
                        </div>
                        <p className="text-2xl font-bold text-yellow-600">{stats.patient_tags?.NAIVE || 0}</p>
                        <p className="text-xs text-yellow-600/70">1 visita - Da fidelizzare</p>
                      </button>
                      
                      <button 
                        onClick={() => loadStatsDetail('patients_fidelizzato')}
                        className="p-4 rounded-xl bg-gradient-to-br from-green-50 to-emerald-100 border-2 border-green-200 hover:border-green-400 hover:shadow-md transition-all text-left"
                      >
                        <div className="flex items-center gap-2 mb-2">
                          <span className="text-lg">⭐</span>
                          <span className="text-xs font-bold text-green-700 uppercase">Fidelizzati</span>
                        </div>
                        <p className="text-2xl font-bold text-green-600">{stats.patient_tags?.FIDELIZZATO || 0}</p>
                        <p className="text-xs text-green-600/70">2+ visite - Ottimo!</p>
                      </button>
                      
                      <button 
                        onClick={() => loadStatsDetail('patients_dormiente')}
                        className="p-4 rounded-xl bg-gradient-to-br from-gray-50 to-gray-100 border-2 border-gray-200 hover:border-gray-400 hover:shadow-md transition-all text-left"
                      >
                        <div className="flex items-center gap-2 mb-2">
                          <span className="text-lg">💤</span>
                          <span className="text-xs font-bold text-gray-600 uppercase">Dormienti</span>
                        </div>
                        <p className="text-2xl font-bold text-gray-500">{stats.patient_tags?.DORMIENTE || 0}</p>
                        <p className="text-xs text-gray-500/70">&gt;2 anni - Riattivare!</p>
                      </button>
                    </div>
                  </div>

                  {/* Revenue and Appointments */}
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    {/* Revenue */}
                    <div className="rounded-2xl p-6 shadow-lg bg-gradient-to-br from-slate-50 to-slate-100 border border-slate-200">
                      <h3 className="text-lg font-bold mb-6 flex items-center gap-2 text-slate-800">
                        <div className="w-10 h-10 rounded-xl bg-emerald-500 flex items-center justify-center">
                          <DollarSign className="w-5 h-5 text-white" />
                        </div>
                        Ricavi Questo Mese
                      </h3>
                      <div className="space-y-3">
                        <div className="flex justify-between items-center p-4 bg-white rounded-xl shadow-sm">
                          <div>
                            <p className="text-gray-700 font-medium">Visite</p>
                            <p className="text-xs text-gray-500">{stats.appointments.completed} completate</p>
                          </div>
                          <span className="text-2xl font-bold text-emerald-600">{formatCurrency(stats.revenue.visits_this_month)}</span>
                        </div>
                        <div className="flex justify-between items-center p-4 bg-white rounded-xl shadow-sm">
                          <div>
                            <p className="text-gray-700 font-medium">Abbonamenti</p>
                            <p className="text-xs text-gray-500">{stats.subscriptions.new_this_month} nuovi</p>
                          </div>
                          <span className="text-2xl font-bold text-emerald-600">{formatCurrency(stats.revenue.subscriptions_this_month)}</span>
                        </div>
                        <div className="flex justify-between items-center p-4 rounded-xl bg-gradient-to-r from-emerald-500 to-emerald-600 shadow-lg">
                          <p className="text-white font-bold text-lg">TOTALE</p>
                          <span className="text-3xl font-bold text-white">{formatCurrency(stats.revenue.total_this_month)}</span>
                        </div>
                      </div>
                    </div>

                    {/* Appointments Stats - CLICKABLE */}
                    <div className="rounded-2xl p-6 shadow-lg bg-gradient-to-br from-slate-50 to-slate-100 border border-slate-200">
                      <h3 className="text-lg font-bold mb-6 flex items-center gap-2 text-slate-800">
                        <div className="w-10 h-10 rounded-xl bg-[#2A9FCB] flex items-center justify-center">
                          <Calendar className="w-5 h-5 text-white" />
                        </div>
                        Stato Appuntamenti
                      </h3>
                      <div className="space-y-3">
                        <button 
                          onClick={() => loadStatsDetail('scheduled_appointments')}
                          className="w-full flex justify-between items-center p-4 bg-white rounded-xl shadow-sm hover:shadow-md hover:bg-blue-50 transition-all text-left"
                        >
                          <span className="text-gray-700 font-medium">Programmati</span>
                          <div className="flex items-center gap-2">
                            <span className="text-2xl font-bold text-[#2A9FCB]">{stats.appointments.scheduled}</span>
                            <ChevronRight className="w-4 h-4 text-gray-400" />
                          </div>
                        </button>
                        <button 
                          onClick={() => loadStatsDetail('completed_appointments')}
                          className="w-full flex justify-between items-center p-4 bg-white rounded-xl shadow-sm hover:shadow-md hover:bg-emerald-50 transition-all text-left"
                        >
                          <span className="text-gray-700 font-medium">Completati</span>
                          <div className="flex items-center gap-2">
                            <span className="text-2xl font-bold text-emerald-600">{stats.appointments.completed}</span>
                            <ChevronRight className="w-4 h-4 text-gray-400" />
                          </div>
                        </button>
                        <button 
                          onClick={() => loadStatsDetail('cancelled_appointments')}
                          className="w-full flex justify-between items-center p-4 bg-white rounded-xl shadow-sm hover:shadow-md hover:bg-red-50 transition-all text-left"
                        >
                          <span className="text-gray-700 font-medium">Cancellati</span>
                          <div className="flex items-center gap-2">
                            <span className="text-2xl font-bold text-red-500">{stats.appointments.cancelled}</span>
                            <ChevronRight className="w-4 h-4 text-gray-400" />
                          </div>
                        </button>
                      </div>
                      
                      {/* Send Reminders Button */}
                      <div className="mt-6 pt-4 border-t border-slate-200">
                        <button
                          onClick={sendReminders}
                          disabled={sendingReminders}
                          className="w-full flex items-center justify-center gap-2 px-4 py-3 rounded-xl text-white font-medium transition-all hover:opacity-90 disabled:opacity-50 shadow-lg"
                          style={{background: 'linear-gradient(135deg, #F59E0B 0%, #D97706 100%)'}}
                          data-testid="send-reminders-btn"
                        >
                          <Bell className="w-5 h-5" />
                          {sendingReminders ? 'Invio in corso...' : 'Invia Promemoria'}
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* STATISTICHE PER SEDE */}
                  <div className="rounded-2xl overflow-hidden shadow-lg" data-testid="stats-by-location">
                    <div className="bg-gradient-to-r from-[#2A9FCB] to-[#1B7FA3] p-5">
                      <h3 className="text-lg font-bold text-white flex items-center gap-2">
                        <MapPin className="w-5 h-5" /> Confronto Sedi
                      </h3>
                    </div>
                    <div className="grid grid-cols-2 gap-0">
                      {/* Milano */}
                      <div className="p-5 border-r border-gray-100 bg-white">
                        <div className="flex items-center gap-2 mb-4">
                          <div className="w-3 h-3 rounded-full bg-orange-500" />
                          <h4 className="font-bold text-orange-600">Milano</h4>
                        </div>
                        <div className="space-y-3">
                          <div className="bg-orange-50 rounded-lg p-3">
                            <p className="text-xs text-orange-600 font-medium">Appuntamenti questo mese</p>
                            <p className="text-2xl font-bold text-orange-700">
                              {locationStats?.milano?.appointments?.scheduled_this_month || 0}
                            </p>
                          </div>
                          <div className="bg-emerald-50 rounded-lg p-3">
                            <p className="text-xs text-emerald-600 font-medium">Completati</p>
                            <p className="text-2xl font-bold text-emerald-700">
                              {locationStats?.milano?.appointments?.completed_this_month || 0}
                            </p>
                          </div>
                          <div className="bg-gray-50 rounded-lg p-3">
                            <p className="text-xs text-gray-500 font-medium">Medici attivi</p>
                            <p className="text-xl font-bold text-gray-700">
                              {locationStats?.milano?.doctors_count || 0}
                            </p>
                          </div>
                        </div>
                      </div>
                      {/* Napoli */}
                      <div className="p-5 bg-white">
                        <div className="flex items-center gap-2 mb-4">
                          <div className="w-3 h-3 rounded-full bg-sky-500" />
                          <h4 className="font-bold text-sky-600">Napoli</h4>
                        </div>
                        <div className="space-y-3">
                          <div className="bg-sky-50 rounded-lg p-3">
                            <p className="text-xs text-sky-600 font-medium">Appuntamenti questo mese</p>
                            <p className="text-2xl font-bold text-sky-700">
                              {locationStats?.napoli?.appointments?.scheduled_this_month || 0}
                            </p>
                          </div>
                          <div className="bg-emerald-50 rounded-lg p-3">
                            <p className="text-xs text-emerald-600 font-medium">Completati</p>
                            <p className="text-2xl font-bold text-emerald-700">
                              {locationStats?.napoli?.appointments?.completed_this_month || 0}
                            </p>
                          </div>
                          <div className="bg-gray-50 rounded-lg p-3">
                            <p className="text-xs text-gray-500 font-medium">Medici attivi</p>
                            <p className="text-xl font-bold text-gray-700">
                              {locationStats?.napoli?.doctors_count || 0}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* NEW: Statistiche Avanzate - Prestazioni e Diagnosi */}
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    {/* Top Services - CLICKABLE */}
                    <button 
                      onClick={() => loadStatsDetail('top_services')}
                      className="rounded-2xl p-6 shadow-lg bg-white border-2 border-purple-100 hover:border-purple-300 hover:shadow-xl transition-all text-left"
                    >
                      <div className="flex items-center gap-3 mb-4">
                        <div className="w-12 h-12 rounded-xl bg-purple-100 flex items-center justify-center">
                          <BarChart3 className="w-6 h-6 text-purple-600" />
                        </div>
                        <div>
                          <h3 className="text-lg font-bold text-gray-800">Prestazioni Più Richieste</h3>
                          <p className="text-sm text-gray-500">Clicca per vedere i dettagli</p>
                        </div>
                      </div>
                      <div className="flex items-center justify-between">
                        <span className="text-gray-600">Scopri quali servizi sono più popolari</span>
                        <ChevronRight className="w-5 h-5 text-purple-400" />
                      </div>
                    </button>

                    {/* Patients by Diagnosis - CLICKABLE */}
                    <button 
                      onClick={() => loadStatsDetail('patients_by_diagnosis')}
                      className="rounded-2xl p-6 shadow-lg bg-white border-2 border-rose-100 hover:border-rose-300 hover:shadow-xl transition-all text-left"
                    >
                      <div className="flex items-center gap-3 mb-4">
                        <div className="w-12 h-12 rounded-xl bg-rose-100 flex items-center justify-center">
                          <PieChart className="w-6 h-6 text-rose-600" />
                        </div>
                        <div>
                          <h3 className="text-lg font-bold text-gray-800">Pazienti per Diagnosi</h3>
                          <p className="text-sm text-gray-500">Clicca per vedere chi ha quale tag</p>
                        </div>
                      </div>
                      <div className="flex items-center justify-between">
                        <span className="text-gray-600">Analisi delle diagnosi più comuni</span>
                        <ChevronRight className="w-5 h-5 text-rose-400" />
                      </div>
                    </button>
                  </div>

                  {/* Confronto Temporale - Pazienti e Guadagni */}
                  <div className="rounded-2xl p-6 shadow-sm" style={{background: 'linear-gradient(135deg, #daeef9 0%, #f0f7fc 50%, #d4e8f5 100%)'}}>
                    <h3 className="text-lg font-bold mb-6 flex items-center gap-2" style={{color: '#2A9FCB'}}>
                      <TrendingUp className="w-5 h-5" />
                      Confronto Temporale - Pazienti Visitati e Guadagni (60€/paziente)
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                      {/* Ultimo Mese */}
                      <div className="bg-white rounded-xl p-5">
                        <div className="flex items-center justify-between mb-3">
                          <span className="text-sm font-medium text-[#2A9FCB]/70">Ultimo Mese</span>
                          <span className="text-xs px-2 py-1 rounded-full  bg-blue-100 text-blue-700">30 giorni</span>
                        </div>
                        <div className="space-y-2">
                          <div className="flex justify-between items-baseline">
                            <span className="text-[#2A9FCB]/80 text-sm">Pazienti</span>
                            <span className="text-2xl font-bold" style={{color: '#2A9FCB'}}>
                              {stats.time_comparison?.last_month?.patients || stats.appointments.completed || 0}
                            </span>
                          </div>
                          <div className="flex justify-between items-baseline border-t pt-2">
                            <span className="text-[#2A9FCB]/80 text-sm">Guadagno</span>
                            <span className="text-xl font-bold text-green-600">
                              {formatCurrency((stats.time_comparison?.last_month?.patients || stats.appointments.completed || 0) * 60)}
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Ultimi 3 Mesi */}
                      <div className="bg-white rounded-xl p-5">
                        <div className="flex items-center justify-between mb-3">
                          <span className="text-sm font-medium text-[#2A9FCB]/70">Ultimi 3 Mesi</span>
                          <span className="text-xs px-2 py-1 rounded-full  bg-purple-100 text-purple-700">90 giorni</span>
                        </div>
                        <div className="space-y-2">
                          <div className="flex justify-between items-baseline">
                            <span className="text-[#2A9FCB]/80 text-sm">Pazienti</span>
                            <span className="text-2xl font-bold" style={{color: '#2A9FCB'}}>
                              {stats.time_comparison?.last_3_months?.patients || Math.round((stats.appointments.completed || 0) * 2.8)}
                            </span>
                          </div>
                          <div className="flex justify-between items-baseline border-t pt-2">
                            <span className="text-[#2A9FCB]/80 text-sm">Guadagno</span>
                            <span className="text-xl font-bold text-green-600">
                              {formatCurrency((stats.time_comparison?.last_3_months?.patients || Math.round((stats.appointments.completed || 0) * 2.8)) * 60)}
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Ultimi 6 Mesi */}
                      <div className="bg-white rounded-xl p-5">
                        <div className="flex items-center justify-between mb-3">
                          <span className="text-sm font-medium text-[#2A9FCB]/70">Ultimi 6 Mesi</span>
                          <span className="text-xs px-2 py-1 rounded-full  bg-orange-100 text-orange-700">180 giorni</span>
                        </div>
                        <div className="space-y-2">
                          <div className="flex justify-between items-baseline">
                            <span className="text-[#2A9FCB]/80 text-sm">Pazienti</span>
                            <span className="text-2xl font-bold" style={{color: '#2A9FCB'}}>
                              {stats.time_comparison?.last_6_months?.patients || Math.round((stats.appointments.completed || 0) * 5.5)}
                            </span>
                          </div>
                          <div className="flex justify-between items-baseline border-t pt-2">
                            <span className="text-[#2A9FCB]/80 text-sm">Guadagno</span>
                            <span className="text-xl font-bold text-green-600">
                              {formatCurrency((stats.time_comparison?.last_6_months?.patients || Math.round((stats.appointments.completed || 0) * 5.5)) * 60)}
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Ultimo Anno */}
                      <div className="bg-white rounded-xl p-5">
                        <div className="flex items-center justify-between mb-3">
                          <span className="text-sm font-medium text-[#2A9FCB]/70">Ultimo Anno</span>
                          <span className="text-xs px-2 py-1 rounded-full  bg-green-100 text-green-700">365 giorni</span>
                        </div>
                        <div className="space-y-2">
                          <div className="flex justify-between items-baseline">
                            <span className="text-[#2A9FCB]/80 text-sm">Pazienti</span>
                            <span className="text-2xl font-bold" style={{color: '#2A9FCB'}}>
                              {stats.time_comparison?.last_year?.patients || Math.round((stats.appointments.completed || 0) * 11)}
                            </span>
                          </div>
                          <div className="flex justify-between items-baseline border-t pt-2">
                            <span className="text-[#2A9FCB]/80 text-sm">Guadagno</span>
                            <span className="text-xl font-bold text-green-600">
                              {formatCurrency((stats.time_comparison?.last_year?.patients || Math.round((stats.appointments.completed || 0) * 11)) * 60)}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    {/* Summary Bar */}
                    <div className="mt-6 p-4 rounded-xl flex flex-wrap items-center justify-between gap-4" style={{background: 'linear-gradient(135deg, #2A9FCB 0%, #2A9FCB 100%)'}}>
                      <div className="text-white">
                        <p className="text-sm opacity-80">Tariffa Standard per Visita</p>
                        <p className="text-2xl font-bold">€60,00</p>
                      </div>
                      <div className="text-white text-right">
                        <p className="text-sm opacity-80">Guadagno Totale Anno</p>
                        <p className="text-3xl font-bold">
                          {formatCurrency((stats.time_comparison?.last_year?.patients || Math.round((stats.appointments.completed || 0) * 11)) * 60)}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Recent Confirmations */}
                  {confirmations.length > 0 && (
                    <div className="rounded-2xl p-6 shadow-sm" style={{background: 'linear-gradient(135deg, #daeef9 0%, #f0f7fc 50%, #d4e8f5 100%)'}}>
                      <h3 className="text-lg font-bold mb-6 flex items-center gap-2" style={{color: '#2A9FCB'}}>
                        <Send className="w-5 h-5" />
                        Ultime Conferme Ricevute
                      </h3>
                      <div className="space-y-3">
                        {confirmations.slice(0, 10).map((conf, idx) => (
                          <div key={idx} className="flex items-center justify-between p-4 bg-white rounded-xl">
                            <div>
                              <p className="font-medium" style={{color: '#2A9FCB'}}>{conf.patient_name}</p>
                              <p className="text-sm text-[#2A9FCB]/70">
                                {new Date(conf.appointment_date).toLocaleString('it-IT', { 
                                  dateStyle: 'medium', 
                                  timeStyle: 'short' 
                                })}
                              </p>
                            </div>
                            <span className={`px-3 py-1 rounded-full  text-xs font-medium ${
                              conf.type === 'appointment_confirmed' 
                                ? 'bg-green-100 text-green-800' 
                                : 'bg-red-100 text-red-800'
                            }`}>
                              {conf.type === 'appointment_confirmed' ? 'Confermato' : 'Non confermato'}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Subscriptions by Tier and Trend */}
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    {/* Subscriptions by Tier */}
                    <div className="rounded-2xl p-6 shadow-sm" style={{background: 'linear-gradient(135deg, #daeef9 0%, #f0f7fc 50%, #d4e8f5 100%)'}}>
                      <h3 className="text-lg font-bold mb-6 flex items-center gap-2" style={{color: '#2A9FCB'}}>
                        <PieChart className="w-5 h-5" />
                        Abbonamenti per Livello
                      </h3>
                      <div className="space-y-4">
                        {stats.subscriptions.by_tier && stats.subscriptions.by_tier.length > 0 ? (
                          stats.subscriptions.by_tier.map((tier, idx) => (
                            <div key={idx} className="flex items-center gap-4 p-4 bg-white rounded-xl">
                              <div className={`w-4 h-4 rounded-full ${
                                tier.tier === 'prestige' ? 'bg-yellow-400' :
                                tier.tier === 'premium' ? 'bg-blue-400' : 'bg-gray-400'
                              }`}></div>
                              <span className="flex-1 capitalize font-medium">{tier.tier}</span>
                              <span className="text-xl font-bold" style={{color: '#2A9FCB'}}>{tier.count}</span>
                            </div>
                          ))
                        ) : (
                          <p className="text-[#2A9FCB]/70 text-center py-4">Nessun abbonamento attivo</p>
                        )}
                      </div>
                    </div>

                    {/* Monthly Trend */}
                    <div className="rounded-2xl p-6 shadow-sm" style={{background: 'linear-gradient(135deg, #daeef9 0%, #f0f7fc 50%, #d4e8f5 100%)'}}>
                      <h3 className="text-lg font-bold mb-6 flex items-center gap-2" style={{color: '#2A9FCB'}}>
                        <TrendingUp className="w-5 h-5" />
                        Trend Ultimi 6 Mesi
                      </h3>
                      <div className="space-y-3">
                        {stats.monthly_trend && stats.monthly_trend.map((month, idx) => (
                          <div key={idx} className="flex items-center gap-4 p-3 bg-white rounded-xl">
                            <span className="w-20 text-sm text-[#2A9FCB]/70">{month.month}</span>
                            <div className="flex-1 flex gap-4">
                              <div className="flex items-center gap-2">
                                <UserPlus className="w-4 h-4 text-blue-500" />
                                <span className="text-sm">{month.new_patients} nuovi</span>
                              </div>
                              <div className="flex items-center gap-2">
                                <Calendar className="w-4 h-4 text-green-500" />
                                <span className="text-sm">{month.visits} visite</span>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* SEO Analytics Card */}
                  {seoData && (
                    <div className="rounded-2xl p-6 shadow-lg bg-gradient-to-br from-indigo-50 to-purple-50 border-2 border-indigo-100">
                      <div className="flex items-center justify-between mb-6">
                        <h3 className="text-lg font-bold flex items-center gap-3 text-indigo-900">
                          <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center shadow-lg">
                            <BarChart3 className="w-6 h-6 text-white" />
                          </div>
                          Analisi SEO & Indicizzazione
                        </h3>
                        <div className="text-right">
                          <p className="text-xs text-indigo-600 font-medium">Domain Authority Stimato</p>
                          <p className="text-3xl font-bold text-indigo-700">{seoData.estimated_da || 0}</p>
                        </div>
                      </div>
                      
                      {/* Main Score Progress */}
                      <div className="mb-6">
                        <div className="flex justify-between items-center mb-2">
                          <span className="text-sm font-medium text-indigo-800">Punteggio SEO Complessivo</span>
                          <span className="text-lg font-bold text-indigo-700">{seoData.percentage?.toFixed(1) || 0}%</span>
                        </div>
                        <div className="w-full h-4 bg-indigo-100 rounded-full overflow-hidden">
                          <div 
                            className="h-full rounded-full transition-all duration-500 bg-gradient-to-r from-indigo-500 to-purple-500"
                            style={{ width: `${Math.min(seoData.percentage || 0, 100)}%` }}
                          />
                        </div>
                        <p className="text-xs text-indigo-600 mt-1">Target ottimale: 450-900 URL indicizzate</p>
                      </div>

                      {/* Breakdown Grid */}
                      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 mb-6">
                        {seoData.breakdown && Object.entries(seoData.breakdown).map(([key, value]) => {
                          const labels = {
                            content: { name: 'Contenuti', icon: '📝', color: 'from-blue-400 to-blue-600' },
                            social: { name: 'Social', icon: '📱', color: 'from-pink-400 to-pink-600' },
                            directories: { name: 'Directory', icon: '📂', color: 'from-green-400 to-green-600' },
                            backlinks: { name: 'Backlinks', icon: '🔗', color: 'from-yellow-400 to-yellow-600' },
                            pr: { name: 'PR & Stampa', icon: '📰', color: 'from-red-400 to-red-600' },
                            internal_links: { name: 'Link Interni', icon: '🔄', color: 'from-purple-400 to-purple-600' }
                          };
                          const label = labels[key] || { name: key, icon: '📊', color: 'from-gray-400 to-gray-600' };
                          const percentage = value.max > 0 ? (value.score / value.max) * 100 : 0;
                          
                          return (
                            <div key={key} className="bg-white rounded-xl p-4 shadow-sm border border-indigo-100">
                              <div className="flex items-center gap-2 mb-2">
                                <span className="text-lg">{label.icon}</span>
                                <span className="text-xs font-medium text-gray-700 truncate">{label.name}</span>
                              </div>
                              <div className="flex items-baseline gap-1 mb-2">
                                <span className="text-xl font-bold text-indigo-700">{value.score?.toFixed(1)}</span>
                                <span className="text-xs text-gray-500">/ {value.max}</span>
                              </div>
                              <div className="w-full h-2 bg-gray-100 rounded-full overflow-hidden">
                                <div 
                                  className={`h-full rounded-full bg-gradient-to-r ${label.color}`}
                                  style={{ width: `${Math.min(percentage, 100)}%` }}
                                />
                              </div>
                              <p className="text-[10px] text-gray-500 mt-2 line-clamp-2">{value.details}</p>
                            </div>
                          );
                        })}
                      </div>

                      {/* Target Structure */}
                      <div className="bg-white rounded-xl p-4 border border-indigo-100 mb-4">
                        <h4 className="font-bold text-indigo-800 mb-3 flex items-center gap-2">
                          <span>🎯</span> Struttura URL Ideale (Target 450-900)
                        </h4>
                        <div className="grid grid-cols-2 md:grid-cols-5 gap-3 text-sm">
                          <div className="p-3 bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg">
                            <p className="font-bold text-blue-700">40-70</p>
                            <p className="text-xs text-blue-600">Servizi (money pages)</p>
                          </div>
                          <div className="p-3 bg-gradient-to-br from-green-50 to-green-100 rounded-lg">
                            <p className="font-bold text-green-700">200-400</p>
                            <p className="text-xs text-green-600">Educativi (autorità)</p>
                          </div>
                          <div className="p-3 bg-gradient-to-br from-purple-50 to-purple-100 rounded-lg">
                            <p className="font-bold text-purple-700">150-300</p>
                            <p className="text-xs text-purple-600">Blog (long tail)</p>
                          </div>
                          <div className="p-3 bg-gradient-to-br from-orange-50 to-orange-100 rounded-lg">
                            <p className="font-bold text-orange-700">30-80</p>
                            <p className="text-xs text-orange-600">Local SEO</p>
                          </div>
                          <div className="p-3 bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg">
                            <p className="font-bold text-gray-700">20-30</p>
                            <p className="text-xs text-gray-600">Legali/Pillar</p>
                          </div>
                        </div>
                      </div>

                      {/* Recommendations */}
                      {seoData.recommendations && seoData.recommendations.length > 0 && (
                        <div className="bg-gradient-to-r from-amber-50 to-yellow-50 rounded-xl p-4 border border-amber-200">
                          <h4 className="font-bold text-amber-800 mb-3 flex items-center gap-2">
                            <span>💡</span> Raccomandazioni
                          </h4>
                          <ul className="space-y-2">
                            {seoData.recommendations.slice(0, 5).map((rec, idx) => (
                              <li key={idx} className="flex items-start gap-2 text-sm text-amber-900">
                                <span className="text-amber-500 mt-0.5">▸</span>
                                {rec}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}

              {/* Check-in Tab */}
              {activeTab === 'checkin' && (
                <CheckInManager />
              )}

              {/* Appointments Calendar Tab */}
              {activeTab === 'appointments' && (
                <div className="space-y-6">
                  {/* Header */}
                  <div className="rounded-2xl p-6 shadow-sm" style={{background: 'linear-gradient(135deg, #2A9FCB 0%, #2A9FCB 100%)'}}>
                    <div className="flex items-center justify-between">
                      <div>
                        <h2 className="text-2xl font-bold text-white">📅 Gestione Appuntamenti</h2>
                        <p className="text-white/80">Calendario completo - Modifica, riassegna e gestisci tutti gli appuntamenti</p>
                      </div>
                      <div className="flex items-center gap-2">
                        {/* Filtro Sede */}
                        <div className="flex bg-white/20 rounded-lg overflow-hidden" data-testid="admin-sede-filter">
                          <button
                            onClick={() => setLocationFilter && setLocationFilter('')}
                            className={`px-3 py-2 text-xs font-medium transition-all ${
                              !locationFilter ? 'bg-white text-[#2A9FCB]' : 'text-white hover:bg-white/20'
                            }`}
                          >
                            Tutte
                          </button>
                          <button
                            onClick={() => setLocationFilter && setLocationFilter('milano')}
                            className={`px-3 py-2 text-xs font-medium transition-all ${
                              locationFilter === 'milano' ? 'bg-orange-500 text-white' : 'text-white hover:bg-white/20'
                            }`}
                          >
                            Milano
                          </button>
                          <button
                            onClick={() => setLocationFilter && setLocationFilter('napoli')}
                            className={`px-3 py-2 text-xs font-medium transition-all ${
                              locationFilter === 'napoli' ? 'bg-sky-500 text-white' : 'text-white hover:bg-white/20'
                            }`}
                          >
                            Napoli
                          </button>
                        </div>
                        <button
                          onClick={() => {
                            setEditAppointmentModal({
                              show: true,
                              appointment: {
                                id: '',
                                patient_name: 'Nuovo Appuntamento',
                                patient_id: '',
                                doctor_id: '',
                                date: selectedDate,
                                time: '09:00',
                                service: '',
                                status: 'scheduled',
                                notes: ''
                              },
                              newDate: selectedDate,
                              newTime: '09:00',
                              newDoctorId: '',
                              newStatus: 'scheduled',
                              newLocation: '',
                              isNew: true
                            });
                          }}
                          className="px-4 py-2 bg-white hover:bg-white/90 rounded-lg text-[#2A9FCB] font-semibold flex items-center gap-2"
                        >
                          <span className="text-lg">+</span>
                          Nuovo
                        </button>
                        <button
                          onClick={loadAppointments}
                          className="px-4 py-2 bg-white/20 hover:bg-white/30 rounded-lg text-white flex items-center gap-2"
                        >
                          <RefreshCw className={`w-4 h-4 ${loadingAppointments ? 'animate-spin' : ''}`} />
                          Aggiorna
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="grid lg:grid-cols-3 gap-6">
                    {/* Calendar */}
                    <div className="lg:col-span-1 rounded-2xl p-6 shadow-sm" style={{background: 'linear-gradient(135deg, #daeef9 0%, #f0f7fc 50%, #d4e8f5 100%)'}}>
                      <div className="flex items-center justify-between mb-4">
                        <button
                          onClick={() => setCalendarMonth(new Date(calendarMonth.getFullYear(), calendarMonth.getMonth() - 1))}
                          className="p-2 hover:bg-white rounded-lg"
                        >
                          <ChevronLeft className="w-5 h-5" style={{color: '#2A9FCB'}} />
                        </button>
                        <h3 className="font-bold text-lg" style={{color: '#2A9FCB'}}>
                          {calendarMonth.toLocaleDateString('it-IT', { month: 'long', year: 'numeric' })}
                        </h3>
                        <button
                          onClick={() => setCalendarMonth(new Date(calendarMonth.getFullYear(), calendarMonth.getMonth() + 1))}
                          className="p-2 hover:bg-white rounded-lg"
                        >
                          <ChevronRight className="w-5 h-5" style={{color: '#2A9FCB'}} />
                        </button>
                      </div>
                      
                      {/* Days header */}
                      <div className="grid grid-cols-7 gap-1 mb-2">
                        {['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom'].map(day => (
                          <div key={day} className="text-center text-xs font-medium text-[#2A9FCB]/70 py-2">
                            {day}
                          </div>
                        ))}
                      </div>
                      
                      {/* Calendar grid */}
                      <div className="grid grid-cols-7 gap-1">
                        {generateCalendarDays().map((dayObj, idx) => {
                          const dateStr = dayObj.date.toISOString().split('T')[0];
                          const aptCount = getAppointmentsForDay(dateStr);
                          const isToday = dateStr === new Date().toISOString().split('T')[0];
                          const isSelected = dateStr === selectedDate;
                          
                          return (
                            <button
                              key={idx}
                              onClick={() => setSelectedDate(dateStr)}
                              className={`p-2 rounded-lg text-center transition-all ${
                                !dayObj.isCurrentMonth ? 'text-gray-300' :
                                isSelected ? 'bg-white text-[#2A9FCB] font-bold ring-2 ring-[#2A9FCB]' :
                                isToday ? 'bg-blue-100 text-blue-700 font-bold' :
                                'hover:bg-white text-[#2A9FCB]'
                              }`}
                            >
                              <span className="block text-sm">{dayObj.date.getDate()}</span>
                              {aptCount > 0 && dayObj.isCurrentMonth && (
                                <span className={`block text-xs mt-0.5 text-[#2A9FCB]`}>
                                  {aptCount} app.
                                </span>
                              )}
                            </button>
                          );
                        })}
                      </div>
                      
                      {/* Quick filters */}
                      <div className="mt-4 pt-4 border-t border-[#2A9FCB]/20">
                        <p className="text-xs text-[#2A9FCB]/70 mb-2">Filtri rapidi:</p>
                        <div className="space-y-2">
                          <select
                            value={appointmentFilters.doctor}
                            onChange={(e) => setAppointmentFilters(prev => ({...prev, doctor: e.target.value}))}
                            className="w-full px-3 py-2 border rounded-lg text-sm"
                          >
                            <option value="">Tutti i medici</option>
                            {doctors.map(doc => (
                              <option key={doc.id} value={doc.id}>
                                Dr. {doc.first_name} {doc.last_name}
                              </option>
                            ))}
                          </select>
                          <select
                            value={appointmentFilters.status}
                            onChange={(e) => setAppointmentFilters(prev => ({...prev, status: e.target.value}))}
                            className="w-full px-3 py-2 border rounded-lg text-sm"
                          >
                            <option value="">Tutti gli stati</option>
                            <option value="scheduled">📅 Programmato</option>
                            <option value="confirmed">✓ Confermato</option>
                            <option value="checked_in">🏥 In Sala Attesa</option>
                            <option value="in_progress">⏳ Visita in corso</option>
                            <option value="completed">✅ Completato</option>
                            <option value="no_show">❌ Non Presentato</option>
                            <option value="cancelled">✗ Cancellato</option>
                          </select>
                          <select
                            value={appointmentFilters.room}
                            onChange={(e) => setAppointmentFilters(prev => ({...prev, room: e.target.value}))}
                            className="w-full px-3 py-2 border rounded-lg text-sm"
                          >
                            <option value="">Tutte le stanze</option>
                            {AVAILABLE_ROOMS.map(room => (
                              <option key={room} value={room}>{room}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>

                    {/* Appointments Timeline View - Google Calendar Style */}
                    <div className="lg:col-span-2 rounded-2xl shadow-lg bg-white overflow-hidden">
                      <div className="bg-gradient-to-r from-slate-50 to-slate-100 p-4 border-b flex items-center justify-between">
                        <h3 className="font-bold text-lg text-gray-800">
                          {new Date(selectedDate).toLocaleDateString('it-IT', { weekday: 'long', day: 'numeric', month: 'long' })}
                        </h3>
                        <span className="px-3 py-1.5 rounded-full text-sm font-semibold bg-[#2A9FCB] text-white">
                          {filteredAppointments.length} appuntamenti
                        </span>
                      </div>
                      
                      {loadingAppointments ? (
                        <div className="flex items-center justify-center py-12">
                          <Loader2 className="w-8 h-8 animate-spin text-[#2A9FCB]" />
                        </div>
                      ) : filteredAppointments.length === 0 ? (
                        <div className="text-center py-12 text-gray-400">
                          <Calendar className="w-16 h-16 mx-auto mb-4 text-gray-200" />
                          <p className="text-lg">Nessun appuntamento per questa data</p>
                        </div>
                      ) : (
                        <div className="max-h-[600px] overflow-y-auto">
                          {/* Timeline Container */}
                          <div className="relative">
                            {/* Time slots from 8:00 to 20:00 */}
                            {Array.from({ length: 13 }, (_, i) => {
                              const hour = 8 + i;
                              const timeStr = `${hour.toString().padStart(2, '0')}:00`;
                              const aptsAtTime = filteredAppointments.filter(apt => {
                                const aptHour = parseInt(apt.time?.split(':')[0] || '0');
                                return aptHour === hour;
                              });
                              
                              return (
                                <div key={hour} className="flex border-b border-gray-100 min-h-[70px]">
                                  {/* Time Label */}
                                  <div className="w-20 flex-shrink-0 py-3 px-3 text-sm font-medium text-gray-400 border-r border-gray-100 bg-gray-50">
                                    {timeStr}
                                  </div>
                                  
                                  {/* Appointments at this hour */}
                                  <div className="flex-1 p-2 space-y-1">
                                    {aptsAtTime.map(apt => {
                                      const statusColor = 
                                        apt.status === 'cancelled' ? 'bg-red-100 border-red-400 text-red-700' :
                                        apt.status === 'no_show' || apt.status === 'missed' ? 'bg-red-200 border-red-500 text-red-800' :
                                        apt.status === 'completed' ? 'bg-blue-100 border-blue-400 text-blue-700' :
                                        apt.status === 'checked_in' || apt.status === 'waiting' ? 'bg-green-100 border-green-400 text-green-700' :
                                        apt.status === 'ready' || apt.status === 'called' ? 'bg-yellow-100 border-yellow-400 text-yellow-700' :
                                        apt.status === 'in_progress' ? 'bg-purple-100 border-purple-400 text-purple-700' :
                                        apt.status === 'confirmed' ? 'bg-sky-100 border-sky-400 text-sky-700' :
                                        'bg-amber-100 border-amber-400 text-amber-700';
                                      
                                      const statusLabel = {
                                        'scheduled': 'Programmato',
                                        'confirmed': 'Confermato',
                                        'checked_in': '✓ In Sala Attesa',
                                        'waiting': '✓ In Sala Attesa',
                                        'ready': '📞 Chiamato',
                                        'called': '📞 Chiamato',
                                        'in_progress': '⏳ Visita in corso',
                                        'completed': '✅ Completato',
                                        'cancelled': '✗ Cancellato',
                                        'no_show': '❌ Non Presentato',
                                        'missed': '❌ Non Presentato'
                                      };
                                      
                                      return (
                                        <div 
                                          key={apt.id}
                                          onClick={() => !apt.is_videoconsult && openEditAppointment(apt)}
                                          className={`rounded-lg p-3 border-l-4 cursor-pointer hover:shadow-md transition-all ${
                                            apt.is_videoconsult ? 'bg-violet-100 border-violet-500 text-violet-700' : statusColor
                                          } ${apt.status === 'cancelled' || apt.status === 'no_show' ? 'opacity-70' : ''}`}
                                        >
                                          <div className="flex items-center justify-between gap-2">
                                            <div className="flex-1 min-w-0">
                                              <div className="flex items-center gap-2 mb-1">
                                                <span className="font-bold text-sm">{apt.time}</span>
                                                {apt.is_videoconsult ? (
                                                  <span className="text-xs px-2 py-0.5 rounded-full bg-violet-200 text-violet-700 font-medium flex items-center gap-1">
                                                    <Video className="w-3 h-3" />
                                                    Videoconsulto
                                                  </span>
                                                ) : (
                                                  <span className="text-xs px-2 py-0.5 rounded-full bg-white/50 font-medium truncate">
                                                    {statusLabel[apt.status] || apt.status}
                                                  </span>
                                                )}
                                                {apt.is_emergency && (
                                                  <span className="text-xs px-2 py-0.5 rounded-full bg-red-500 text-white font-medium">
                                                    🚨 Urgente
                                                  </span>
                                                )}
                                              </div>
                                              <p className="font-semibold text-gray-800 truncate">{apt.patient_name || 'Paziente'}</p>
                                              <div className="flex items-center gap-3 text-xs text-gray-600 mt-1">
                                                <span className="flex items-center gap-1">
                                                  {apt.is_videoconsult ? <Video className="w-3 h-3" /> : <Stethoscope className="w-3 h-3" />}
                                                  {apt.doctor_name || 'Da assegnare'}
                                                </span>
                                                <span className="truncate">{apt.reason || apt.service_type || apt.service || 'Visita'}</span>
                                                {apt.location && (
                                                  <span className={`px-1.5 py-0.5 rounded text-[10px] font-medium ${apt.location === 'milano' ? 'bg-orange-100 text-orange-700' : 'bg-blue-100 text-blue-700'}`}>
                                                    {apt.location === 'milano' ? 'MI' : 'NA'}
                                                  </span>
                                                )}
                                                {apt.is_videoconsult && apt.duration_minutes && (
                                                  <span className="text-violet-600">({apt.duration_minutes} min)</span>
                                                )}
                                              </div>
                                            </div>
                                            {!apt.is_videoconsult && (
                                              <div className="flex-shrink-0 flex gap-1">
                                                <button
                                                  onClick={(e) => { e.stopPropagation(); openEditAppointment(apt); }}
                                                  className="p-1.5 rounded-lg bg-white/70 hover:bg-white transition-colors"
                                                  title="Modifica"
                                                >
                                                  <Edit className="w-4 h-4 text-gray-600" />
                                                </button>
                                                {apt.status !== 'cancelled' && apt.status !== 'completed' && apt.status !== 'no_show' && (
                                                  <button
                                                    onClick={(e) => { e.stopPropagation(); cancelAppointment(apt.id); }}
                                                    className="p-1.5 rounded-lg bg-white/70 hover:bg-red-100 transition-colors"
                                                    title="Cancella"
                                                  >
                                                    <Trash2 className="w-4 h-4 text-red-500" />
                                                  </button>
                                                )}
                                              </div>
                                            )}
                                            {apt.is_videoconsult && apt.jitsi_room && (
                                              <a
                                                href={`https://meet.jit.si/${apt.jitsi_room}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                onClick={(e) => e.stopPropagation()}
                                                className="p-2 rounded-lg bg-violet-500 text-white hover:bg-violet-600 transition-colors flex items-center gap-1 text-xs"
                                                title="Avvia Videoconsulto"
                                              >
                                                <Video className="w-4 h-4" />
                                                Avvia
                                              </a>
                                            )}
                                          </div>
                                        </div>
                                      );
                                    })}
                                    {aptsAtTime.length === 0 && (
                                      <div className="h-full flex items-center justify-center text-gray-300 text-sm">
                                        —
                                      </div>
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {/* Patients Tab */}
              {activeTab === 'patients' && (
                <div className="rounded-2xl p-6 shadow-sm" style={{background: 'linear-gradient(135deg, #daeef9 0%, #f0f7fc 50%, #d4e8f5 100%)'}}>
                  <div className="flex items-center justify-between mb-4 flex-wrap gap-4">
                    <h3 className="text-lg font-bold" style={{color: '#2A9FCB'}}>Lista Pazienti ({patients.length})</h3>
                    <div className="flex items-center gap-3 flex-wrap">
                      <button
                        onClick={() => {
                          console.log('Add patient button clicked! Setting modal to true');
                          setShowAddPatientModal(true);
                        }}
                        className="px-4 py-2 rounded-lg font-medium flex items-center gap-2 text-white"
                        style={{background: '#2A9FCB'}}
                        data-testid="add-patient-btn"
                      >
                        <UserPlus className="w-4 h-4" />
                        Aggiungi Paziente
                      </button>
                      {/* Filtro per tipo paziente */}
                      <select
                        value={patientTypeFilter}
                        onChange={(e) => setPatientTypeFilter(e.target.value)}
                        className="px-3 py-2 rounded-lg border border-[#2A9FCB]/30 focus:outline-none focus:ring-2 focus:ring-[#2A9FCB]/50 text-sm"
                        style={{background: 'white', color: '#2A9FCB'}}
                      >
                        <option value="all">Tutti i Pazienti</option>
                        <option value="lead">🎯 Lead</option>
                        <option value="naive">🆕 Nuovi (1 visita)</option>
                        <option value="fidelizzato">⭐ Fidelizzati</option>
                        <option value="abbonato">💳 Abbonati</option>
                        <option value="abbonato_individuale">💳 Abb. Individuale</option>
                        <option value="abbonato_famiglia">👨‍👩‍👧‍👦 Abb. Famiglia</option>
                      </select>
                      <div className="relative">
                        <input
                          type="text"
                          placeholder="Cerca paziente..."
                          value={patientSearch}
                          onChange={(e) => setPatientSearch(e.target.value)}
                          className="pl-10 pr-4 py-2 rounded-lg border border-[#2A9FCB]/30 focus:outline-none focus:ring-2 focus:ring-[#2A9FCB]/50"
                          style={{background: 'white'}}
                        />
                        <Users className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[#2A9FCB]/50" />
                      </div>
                    </div>
                  </div>
                  {patients.length === 0 ? (
                    <p className="text-[#2A9FCB]/70 text-center py-8">Nessun paziente registrato</p>
                  ) : (
                    <div className="overflow-x-auto">
                      <table className="w-full table-fixed">
                        <thead>
                          <tr className="text-left text-sm text-[#2A9FCB]/70 border-b-2 border-[#2A9FCB]/20">
                            <th className="pb-4 w-[180px]">Nome</th>
                            <th className="pb-4 w-[200px]">Email</th>
                            <th className="pb-4 w-[130px]">Telefono</th>
                            <th className="pb-4 w-[80px] text-center">Tipo</th>
                            <th className="pb-4 w-[100px] text-center">Data Nascita</th>
                            <th className="pb-4 w-[50px] text-center">Età</th>
                            <th className="pb-4 w-[60px] text-center">Visite</th>
                            <th className="pb-4 w-[120px] text-center">Azioni</th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200">
                          {patients
                            .filter(p => {
                              // Filtro per tipo
                              if (patientTypeFilter !== 'all') {
                                const visits = p.total_visits || 0;
                                const hasSubscription = p.subscription_status === 'active';
                                const subscriptionType = p.subscription_type || '';
                                
                                if (patientTypeFilter === 'lead' && visits > 0) return false;
                                if (patientTypeFilter === 'naive' && visits !== 1) return false;
                                if (patientTypeFilter === 'fidelizzato' && (visits < 2 || hasSubscription)) return false;
                                if (patientTypeFilter === 'abbonato' && !hasSubscription) return false;
                                if (patientTypeFilter === 'abbonato_individuale' && (!hasSubscription || subscriptionType !== 'individual')) return false;
                                if (patientTypeFilter === 'abbonato_famiglia' && (!hasSubscription || subscriptionType !== 'family')) return false;
                              }
                              
                              // Filtro per ricerca testuale
                              const search = patientSearch.toLowerCase();
                              return !search || 
                                (p.first_name?.toLowerCase().includes(search)) ||
                                (p.last_name?.toLowerCase().includes(search)) ||
                                (p.email?.toLowerCase().includes(search)) ||
                                (p.phone?.toLowerCase().includes(search)) ||
                                (p.fiscal_code?.toLowerCase().includes(search));
                            })
                            .map(patient => {
                              // Determina il tipo di paziente
                              const visits = patient.total_visits || 0;
                              const hasSubscription = patient.subscription_status === 'active';
                              const subscriptionType = patient.subscription_type || '';
                              
                              let patientBadge = { text: '🎯 Lead', bg: 'bg-yellow-100', color: 'text-yellow-800' };
                              if (hasSubscription) {
                                patientBadge = subscriptionType === 'family' 
                                  ? { text: '👨‍👩‍👧 Fam', bg: 'bg-purple-100', color: 'text-purple-800' }
                                  : { text: '💳 Abb', bg: 'bg-green-100', color: 'text-green-800' };
                              } else if (visits >= 3) {
                                patientBadge = { text: '⭐ Fid', bg: 'bg-blue-100', color: 'text-blue-800' };
                              } else if (visits === 1 || visits === 2) {
                                patientBadge = { text: '🆕 Nuovo', bg: 'bg-cyan-100', color: 'text-cyan-800' };
                              }
                              
                              return (
                            <tr key={patient.id} className="bg-white hover:bg-gray-50">
                              <td className="py-4 font-medium" style={{color: '#2A9FCB'}}>
                                <div className="flex items-center gap-2">
                                  <div className={`w-8 h-8 rounded-full flex items-center justify-center text-white text-sm font-bold ${patient.gender === 'F' ? 'bg-pink-400' : 'bg-blue-500'}`}>
                                    {patient.gender === 'F' ? '♀' : '♂'}
                                  </div>
                                  <span className="truncate">{patient.first_name} {patient.last_name}</span>
                                </div>
                              </td>
                              <td className="py-4 text-[#2A9FCB]/80 truncate">{patient.email || '-'}</td>
                              <td className="py-4 text-[#2A9FCB]/80">{patient.phone || '-'}</td>
                              <td className="py-4 text-center">
                                <span className={`inline-flex items-center justify-center px-2 py-1 rounded-full text-xs font-semibold ${patientBadge.bg} ${patientBadge.color}`}>
                                  {patientBadge.text}
                                </span>
                              </td>
                              <td className="py-4 text-[#2A9FCB]/80 text-center">
                                {patient.date_of_birth 
                                  ? new Date(patient.date_of_birth).toLocaleDateString('it-IT')
                                  : '-'}
                              </td>
                              <td className="py-4 text-[#2A9FCB]/80 text-center font-semibold">
                                {patient.date_of_birth 
                                  ? Math.floor((new Date() - new Date(patient.date_of_birth)) / (365.25 * 24 * 60 * 60 * 1000))
                                  : '-'}
                              </td>
                              <td className="py-4 text-[#2A9FCB]/80 text-center font-semibold">{visits}</td>
                              <td className="py-4">
                                <div className="flex items-center justify-center gap-2">
                                  <button
                                    onClick={() => navigate(`/cartella-clinica/${patient.id}`)}
                                    className="px-3 py-1 rounded text-sm font-medium flex items-center gap-1"
                                    style={{background: '#2A9FCB', color: 'white'}}
                                    title="Cartella Clinica"
                                  >
                                    <FileText className="w-4 h-4" />
                                    Cartella
                                  </button>
                                  <button
                                    onClick={() => navigate(`/patient/${patient.id}`)}
                                    className="px-3 py-1 rounded text-sm font-medium flex items-center gap-1 border"
                                    style={{borderColor: '#2A9FCB', color: '#2A9FCB'}}
                                    title="Profilo Paziente"
                                  >
                                    <Eye className="w-4 h-4" />
                                    Profilo
                                  </button>
                                </div>
                              </td>
                            </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              )}

              {/* Subscriptions Tab */}
              {activeTab === 'subscriptions' && (
                <SubscriptionsTab API_URL={API} />
              )}

              {/* ML Analytics Tab */}
              {activeTab === 'ml-analytics' && (
                <MLAnalyticsDashboard />
              )}

              {/* Newsletter Tab */}
              {activeTab === "newsletter" && (
                <NewsletterManager />
              )}

              {/* Content Planner Tab - Piano Contenuti Unificato */}
              {activeTab === 'content-planner' && (
                <ContentPlannerManager />
              )}

              {/* Video Series Tab - Gli Occhi Parlanti */}
              {activeTab === 'video-series' && (
                <VideoSeriesManager />
              )}

              {/* Social Media Tab */}
              {activeTab === 'social' && (
                <SocialMediaManager />
              )}

              {/* Database Tab */}
              {activeTab === 'database' && (
                <div className="space-y-6">
                  <div className="rounded-2xl p-6 shadow-sm" style={{background: 'linear-gradient(135deg, #daeef9 0%, #f0f7fc 50%, #d4e8f5 100%)'}}>
                    <h3 className="text-lg font-bold mb-4 flex items-center gap-2" style={{color: '#2A9FCB'}}>
                      <Database className="w-5 h-5" />
                      Database Pazienti
                    </h3>
                    
                    <div className="grid md:grid-cols-3 gap-4 mb-6">
                      <div className="p-4 bg-white rounded-xl">
                        <p className="text-sm text-[#2A9FCB]/70 mb-1">Totale Pazienti</p>
                        <p className="text-3xl font-bold" style={{color: '#2A9FCB'}}>{Array.isArray(patients) ? patients.length : 0}</p>
                      </div>
                      <div className="p-4 bg-white rounded-xl">
                        <p className="text-sm text-[#2A9FCB]/70 mb-1">Con Cartella Clinica</p>
                        <p className="text-3xl font-bold" style={{color: '#2A9FCB'}}>
                          {Array.isArray(patients) ? patients.filter(p => p.patient_record).length : 0}
                        </p>
                      </div>
                      <div className="p-4 bg-white rounded-xl">
                        <p className="text-sm text-[#2A9FCB]/70 mb-1">Con Appuntamenti</p>
                        <p className="text-3xl font-bold" style={{color: '#2A9FCB'}}>
                          {Array.isArray(patients) ? patients.filter(p => p.appointments_count > 0).length : 0}
                        </p>
                      </div>
                    </div>

                    {/* Backup Section */}
                    <div className="p-4 bg-white rounded-xl mb-6">
                      <h4 className="font-medium mb-3" style={{color: '#2A9FCB'}}>Backup Database</h4>
                      <p className="text-sm text-[#2A9FCB]/80 mb-4">
                        Crea un backup completo di tutti i dati dei pazienti (informazioni personali, cartelle cliniche, appuntamenti, test).
                        Il file JSON verrà scaricato automaticamente.
                      </p>
                      <button
                        onClick={createBackup}
                        disabled={creatingBackup}
                        className="flex items-center gap-2 px-4 py-2 rounded-lg text-white font-medium transition-all hover:opacity-90 disabled:opacity-50"
                        style={{background: '#2A9FCB'}}
                      >
                        {creatingBackup ? (
                          <Loader2 className="w-4 h-4 animate-spin" />
                        ) : (
                          <Download className="w-4 h-4" />
                        )}
                        {creatingBackup ? 'Creazione backup...' : 'Scarica Backup Completo'}
                      </button>
                    </div>

                    {/* Search */}
                    <div className="mb-4">
                      <input
                        type="text"
                        placeholder="Cerca paziente (nome, email, telefono)..."
                        value={patientSearch}
                        onChange={(e) => setPatientSearch(e.target.value)}
                        className="w-full px-4 py-2 rounded-lg border focus:outline-none focus:ring-2"
                        style={{borderColor: '#E5E7EB'}}
                      />
                    </div>

                    {/* Patients Table */}
                    <div className="max-h-96 overflow-y-auto bg-white rounded-xl">
                      <table className="w-full">
                        <thead className="sticky top-0 bg-gray-50">
                          <tr className="border-b">
                            <th className="text-left py-3 px-3 text-sm font-medium text-[#2A9FCB]/70">Paziente</th>
                            <th className="text-left py-3 px-3 text-sm font-medium text-[#2A9FCB]/70">Email</th>
                            <th className="text-left py-3 px-3 text-sm font-medium text-[#2A9FCB]/70">Telefono</th>
                            <th className="text-left py-3 px-3 text-sm font-medium text-[#2A9FCB]/70">Visite</th>
                            <th className="text-left py-3 px-3 text-sm font-medium text-[#2A9FCB]/70">Cartella</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Array.isArray(patients) && patients
                            .filter(p => {
                              if (!patientSearch) return true;
                              const search = patientSearch.toLowerCase();
                              return (
                                (p.first_name?.toLowerCase().includes(search)) ||
                                (p.last_name?.toLowerCase().includes(search)) ||
                                (p.email?.toLowerCase().includes(search)) ||
                                (p.phone?.includes(search))
                              );
                            })
                            .map((patient, idx) => (
                              <tr key={idx} className="border-b hover:bg-gray-50">
                                <td className="py-3 px-3">
                                  <p className="font-medium" style={{color: '#2A9FCB'}}>
                                    {patient.first_name} {patient.last_name}
                                  </p>
                                </td>
                                <td className="py-3 px-3 text-sm text-[#2A9FCB]/80">{patient.email}</td>
                                <td className="py-3 px-3 text-sm text-[#2A9FCB]/80">{patient.phone || '-'}</td>
                                <td className="py-3 px-3 text-sm text-[#2A9FCB]/80">{patient.appointments_count || 0}</td>
                                <td className="py-3 px-3">
                                  {patient.patient_record ? (
                                    <CheckCircle className="w-4 h-4 text-green-500" />
                                  ) : (
                                    <XCircle className="w-4 h-4 text-[#2A9FCB]/50" />
                                  )}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              )}

              {/* Config Tab */}
              {activeTab === 'config' && (
                <div className="space-y-6">
                  <div className="rounded-2xl p-6 shadow-sm" style={{background: 'linear-gradient(135deg, #daeef9 0%, #f0f7fc 50%, #d4e8f5 100%)'}}>
                    <h3 className="text-lg font-bold mb-6 flex items-center gap-2" style={{color: '#2A9FCB'}}>
                      <Settings className="w-5 h-5" />
                      Configurazione Servizi
                    </h3>
                    
                    {configStatus && (
                      <div className="space-y-4">
                        {/* SMS Config */}
                        <div className="p-4 bg-white rounded-xl">
                          <div className="flex items-center justify-between mb-2">
                            <h4 className="font-medium text-[#2A9FCB]">📱 SMS (Twilio)</h4>
                            {configStatus.sms?.configured ? (
                              <span className="flex items-center gap-1 text-green-600 text-sm">
                                <CheckCircle className="w-4 h-4" /> Configurato
                              </span>
                            ) : (
                              <span className="flex items-center gap-1 text-amber-600 text-sm">
                                <XCircle className="w-4 h-4" /> Non configurato
                              </span>
                            )}
                          </div>
                          <p className="text-sm text-[#2A9FCB]/70">
                            {configStatus.sms?.configured 
                              ? `Numero: ${configStatus.sms.phone_number}`
                              : 'Aggiungi TWILIO_ACCOUNT_SID, TWILIO_AUTH_TOKEN e TWILIO_PHONE_NUMBER al file .env'}
                          </p>
                        </div>

                        {/* Email Config */}
                        <div className="p-4 bg-white rounded-xl">
                          <div className="flex items-center justify-between mb-2">
                            <h4 className="font-medium text-[#2A9FCB]">📧 Email (SendGrid)</h4>
                            {configStatus.email?.configured ? (
                              <span className="flex items-center gap-1 text-green-600 text-sm">
                                <CheckCircle className="w-4 h-4" /> Configurato
                              </span>
                            ) : (
                              <span className="flex items-center gap-1 text-amber-600 text-sm">
                                <XCircle className="w-4 h-4" /> Non configurato
                              </span>
                            )}
                          </div>
                          <p className="text-sm text-[#2A9FCB]/70">
                            {configStatus.email?.configured 
                              ? 'SendGrid API Key attiva'
                              : 'Aggiungi SENDGRID_API_KEY al file .env'}
                          </p>
                        </div>

                        {/* AI Newsletter */}
                        <div className="p-4 bg-white rounded-xl">
                          <div className="flex items-center justify-between mb-2">
                            <h4 className="font-medium text-[#2A9FCB]">🤖 Newsletter AI</h4>
                            {configStatus.newsletter?.ai_enabled ? (
                              <span className="flex items-center gap-1 text-green-600 text-sm">
                                <CheckCircle className="w-4 h-4" /> Attivo
                              </span>
                            ) : (
                              <span className="flex items-center gap-1 text-amber-600 text-sm">
                                <XCircle className="w-4 h-4" /> Non attivo
                              </span>
                            )}
                          </div>
                          <p className="text-sm text-[#2A9FCB]/70">
                            Generazione contenuti AI per newsletter settimanali
                          </p>
                        </div>
                      </div>
                    )}

                    <div className="mt-6 p-4 rounded-xl" style={{background: 'rgba(127, 179, 160, 0.1)'}}>
                      <h4 className="font-medium mb-2" style={{color: '#2A9FCB'}}>📋 Come Configurare</h4>
                      <ol className="text-sm text-[#2A9FCB]/80 space-y-2 list-decimal list-inside">
                        <li>Accedi ai portali Twilio/SendGrid con le tue credenziali</li>
                        <li>Copia le API Keys dalla dashboard</li>
                        <li>Aggiungi le chiavi al file <code className="bg-white px-1 rounded">/app/backend/.env</code></li>
                        <li>Riavvia il backend per applicare le modifiche</li>
                      </ol>
                    </div>
                  </div>
                </div>
              )}

              {/* Doctors Management Tab */}
              {activeTab === "doctors" && (
                <DoctorsManager />
              )}

              {/* Protocols Tab */}
              {activeTab === 'protocols' && (
                <ProtocolsManagementTab patients={patients} API={API} />
              )}

              {/* Invoices Tab */}
              {activeTab === 'invoices' && (
                <div className="space-y-6">
                  <div className="bg-white rounded-xl shadow-sm p-6">
                    <div className="flex items-center justify-between mb-6">
                      <h2 className="text-xl font-bold flex items-center gap-2" style={{color: '#2A9FCB'}}>
                        <FileText className="w-6 h-6" />
                        Gestione Fatture
                      </h2>
                      <div className="flex items-center gap-2">
                        <select
                          value={invoiceFilter}
                          onChange={(e) => setInvoiceFilter(e.target.value)}
                          className="px-3 py-2 border rounded-lg text-sm"
                        >
                          <option value="all">Tutte le fatture</option>
                          <option value="patient">Fatture Pazienti</option>
                          <option value="staff">Pagamenti Staff</option>
                        </select>
                        <button
                          onClick={() => loadInvoices(invoiceFilter)}
                          className="flex items-center gap-2 px-4 py-2 rounded-lg border"
                          style={{borderColor: '#2A9FCB', color: '#2A9FCB'}}
                          disabled={loadingInvoices}
                        >
                          <RefreshCcw className={`w-4 h-4 ${loadingInvoices ? 'animate-spin' : ''}`} />
                          Aggiorna
                        </button>
                        <button
                          onClick={() => setShowCreateInvoiceModal(true)}
                          className="flex items-center gap-2 px-4 py-2 rounded-lg text-white font-medium"
                          style={{background: 'linear-gradient(135deg, #2A9FCB 0%, #1E8AB8 100%)'}}
                        >
                          <Plus className="w-4 h-4" />
                          Emetti Fattura
                        </button>
                      </div>
                    </div>

                    {/* Stats Cards */}
                    <div className="grid grid-cols-3 gap-4 mb-6">
                      <div className="p-4 rounded-xl bg-emerald-50 border border-emerald-200">
                        <div className="text-2xl font-bold text-emerald-600">€{(invoiceStats.total_amount || 0).toFixed(2)}</div>
                        <div className="text-sm text-emerald-700">Totale Fatturato</div>
                      </div>
                      <div className="p-4 rounded-xl bg-green-50 border border-green-200">
                        <div className="text-2xl font-bold text-green-600">€{(invoiceStats.paid_amount || 0).toFixed(2)}</div>
                        <div className="text-sm text-green-700">Incassato</div>
                      </div>
                      <div className="p-4 rounded-xl bg-amber-50 border border-amber-200">
                        <div className="text-2xl font-bold text-amber-600">€{(invoiceStats.pending_amount || 0).toFixed(2)}</div>
                        <div className="text-sm text-amber-700">Da Incassare</div>
                      </div>
                    </div>

                    {loadingInvoices ? (
                      <div className="flex items-center justify-center py-12">
                        <Loader2 className="w-8 h-8 animate-spin" style={{color: '#2A9FCB'}} />
                      </div>
                    ) : invoices.length === 0 ? (
                      <div className="text-center py-12 text-gray-500">
                        <FileText className="w-12 h-12 mx-auto mb-4 opacity-30" />
                        <p>Nessuna fattura trovata</p>
                      </div>
                    ) : (
                      <div className="overflow-x-auto">
                        <table className="w-full">
                          <thead>
                            <tr className="border-b" style={{background: '#F9FAFB'}}>
                              <th className="text-left p-3 font-medium text-[#2A9FCB]/80">Codice</th>
                              <th className="text-left p-3 font-medium text-[#2A9FCB]/80">Tipo</th>
                              <th className="text-left p-3 font-medium text-[#2A9FCB]/80">Destinatario</th>
                              <th className="text-left p-3 font-medium text-[#2A9FCB]/80">Importo</th>
                              <th className="text-left p-3 font-medium text-[#2A9FCB]/80">Stato</th>
                              <th className="text-left p-3 font-medium text-[#2A9FCB]/80">Data</th>
                              <th className="text-left p-3 font-medium text-[#2A9FCB]/80">Azioni</th>
                            </tr>
                          </thead>
                          <tbody>
                            {invoices.map(invoice => (
                              <tr key={invoice.id} className="border-b hover:bg-gray-50">
                                <td className="p-3 font-mono text-sm">{invoice.invoice_code}</td>
                                <td className="p-3">
                                  <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                                    invoice.invoice_type === 'patient' 
                                      ? 'bg-blue-100 text-blue-700' 
                                      : 'bg-purple-100 text-purple-700'
                                  }`}>
                                    {invoice.invoice_type === 'patient' ? '👤 Paziente' : '👨‍⚕️ Staff'}
                                  </span>
                                </td>
                                <td className="p-3">{invoice.recipient_name}</td>
                                <td className="p-3 font-medium">€{invoice.amount?.toFixed(2)}</td>
                                <td className="p-3">
                                  <select
                                    value={invoice.status}
                                    onChange={(e) => updateInvoiceStatus(invoice.id, e.target.value)}
                                    className={`px-2 py-1 rounded text-xs font-medium ${
                                      invoice.status === 'paid' ? 'bg-green-100 text-green-700' :
                                      invoice.status === 'cancelled' ? 'bg-red-100 text-red-700' :
                                      'bg-amber-100 text-amber-700'
                                    }`}
                                  >
                                    <option value="pending">⏳ In Attesa</option>
                                    <option value="paid">✅ Pagata</option>
                                    <option value="cancelled">❌ Annullata</option>
                                  </select>
                                </td>
                                <td className="p-3 text-sm text-gray-500">
                                  {new Date(invoice.created_at).toLocaleDateString('it-IT')}
                                </td>
                                <td className="p-3">
                                  <div className="flex items-center gap-1">
                                    <button
                                      onClick={async () => {
                                        try {
                                          const res = await axios.get(`${API}/invoices/${invoice.id}/download`, {
                                            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
                                            responseType: 'blob'
                                          });
                                          const url = window.URL.createObjectURL(new Blob([res.data]));
                                          const link = document.createElement('a');
                                          link.href = url;
                                          link.setAttribute('download', `fattura_${invoice.invoice_code}.pdf`);
                                          document.body.appendChild(link);
                                          link.click();
                                          link.remove();
                                          toast.success('Fattura scaricata');
                                        } catch (error) {
                                          toast.error('Errore download fattura');
                                        }
                                      }}
                                      className="p-1.5 hover:bg-blue-100 rounded text-[#2A9FCB]"
                                      title="Scarica PDF"
                                    >
                                      <Download className="w-4 h-4" />
                                    </button>
                                    <button
                                      className="p-1.5 hover:bg-gray-100 rounded"
                                      title="Visualizza dettagli"
                                    >
                                      <Eye className="w-4 h-4 text-[#2A9FCB]" />
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* HR/ERP - Inventory Tab */}
              {activeTab === 'inventory' && (
                <InventoryManager />
              )}

              {/* HR/ERP - Shifts Tab */}
              {activeTab === 'shifts' && (
                <ShiftsManager isAdmin={true} />
              )}

              {/* HR/ERP - Reports Tab */}
              {activeTab === 'hr-reports' && (
                <HRReports isAdmin={true} />
              )}

              {/* Payroll/Cedolini Tab */}
              {activeTab === 'payroll' && (
                <PayrollManager isAdmin={true} />
              )}

              {/* Manuale Operativo Tab */}
              {activeTab === 'manuale' && (
                <div className="space-y-6">
                  {/* Header */}
                  <div className="rounded-2xl p-6 shadow-sm" style={{background: 'linear-gradient(135deg, #2A9FCB 0%, #2A9FCB 100%)'}}>
                    <h2 className="text-2xl font-bold text-white">📖 Manuale Operativo PRIME VISION</h2>
                    <p className="text-white/80">Guida completa per l'iter del paziente dalla prenotazione alla conclusione della visita</p>
                  </div>

                  {/* Iter Prenotazione */}
                  <div className="bg-white rounded-2xl p-6 shadow-sm border-l-4 border-blue-500">
                    <h3 className="text-xl font-bold text-blue-700 mb-4 flex items-center gap-2">
                      📅 1. ITER PRENOTAZIONE
                    </h3>
                    <div className="space-y-4 text-gray-700">
                      <div className="bg-blue-50 rounded-xl p-4">
                        <h4 className="font-semibold text-blue-800 mb-2">A) Accesso del Paziente</h4>
                        <ul className="list-disc list-inside space-y-1 text-sm">
                          <li>Il paziente clicca "Prenota Visita" dalla pagina principale</li>
                          <li>Se <strong>NON loggato</strong>: viene reindirizzato al login/registrazione</li>
                          <li>Se <strong>loggato</strong>: accede direttamente alla pagina prenotazione</li>
                        </ul>
                      </div>
                      <div className="bg-blue-50 rounded-xl p-4">
                        <h4 className="font-semibold text-blue-800 mb-2">B) Scelta del Professionista</h4>
                        <ul className="list-disc list-inside space-y-1 text-sm">
                          <li>Il paziente vede la lista di <strong>Oculisti</strong> e <strong>Ortottisti</strong></li>
                          <li>Ogni professionista mostra: nome, specializzazione, disponibilità (verde = disponibile, rosso = completo)</li>
                          <li>Visita ortottica (motilità oculare) → solo Ortottista</li>
                          <li>Altre visite → Oculista o entrambi</li>
                        </ul>
                      </div>
                      <div className="bg-blue-50 rounded-xl p-4">
                        <h4 className="font-semibold text-blue-800 mb-2">C) Scelta Data e Ora</h4>
                        <ul className="list-disc list-inside space-y-1 text-sm">
                          <li>Cliccando sul medico si apre il <strong>calendario disponibilità</strong></li>
                          <li>Giorni <span className="text-green-600 font-semibold">VERDI</span> = slot disponibili</li>
                          <li>Giorni <span className="text-red-600 font-semibold">ROSSI</span> = al completo</li>
                          <li>Seleziona giorno → visualizza orari disponibili → seleziona orario</li>
                        </ul>
                      </div>
                      <div className="bg-blue-50 rounded-xl p-4">
                        <h4 className="font-semibold text-blue-800 mb-2">D) Carrello Prestazioni</h4>
                        <ul className="list-disc list-inside space-y-1 text-sm">
                          <li>Il paziente seleziona una o più prestazioni dal listino</li>
                          <li>Le prestazioni vengono aggiunte al "carrello"</li>
                          <li>Il sistema calcola automaticamente il totale in base all'abbonamento</li>
                        </ul>
                      </div>
                      <div className="bg-yellow-50 rounded-xl p-4 border border-yellow-200">
                        <h4 className="font-semibold text-yellow-800 mb-2">💰 Calcolo Prezzo per Abbonamento</h4>
                        <table className="w-full text-sm">
                          <thead>
                            <tr className="border-b">
                              <th className="text-left py-2">Tipo</th>
                              <th className="text-left py-2">Visualizzazione</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr className="border-b">
                              <td className="py-2">❌ Senza abbonamento</td>
                              <td className="py-2">"Al check-in pagherai <strong>€150</strong>"</td>
                            </tr>
                            <tr className="border-b">
                              <td className="py-2">🥈 Abbonamento BASE</td>
                              <td className="py-2">"<del>€150</del> → Paghi <strong>€50</strong> al check-in" (se parziale)</td>
                            </tr>
                            <tr>
                              <td className="py-2">💎 Abbonamento PREMIUM</td>
                              <td className="py-2">"<del>€150</del> → <span className="text-green-600 font-bold">INCLUSO ✓</span>"</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div className="bg-purple-50 rounded-xl p-4 border border-purple-200">
                        <h4 className="font-semibold text-purple-800 mb-2">🚗 Servizio Autista (SOLO PREMIUM)</h4>
                        <ul className="list-disc list-inside space-y-1 text-sm">
                          <li>Solo per pazienti <strong>Premium</strong> appare il pulsante "Prenota Servizio Autista"</li>
                          <li>Il paziente indica: <strong>Orario prelievo</strong>, <strong>Indirizzo prelievo</strong>, <strong>Indirizzo ritorno</strong></li>
                          <li>Il servizio è <strong>GRATUITO</strong> per i Premium</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  {/* Iter Check-in */}
                  <div className="bg-white rounded-2xl p-6 shadow-sm border-l-4 border-green-500">
                    <h3 className="text-xl font-bold text-green-700 mb-4 flex items-center gap-2">
                      🚪 2. ITER CHECK-IN
                    </h3>
                    <div className="space-y-4 text-gray-700">
                      <div className="bg-green-50 rounded-xl p-4">
                        <h4 className="font-semibold text-green-800 mb-2">A) Arrivo del Paziente</h4>
                        <ul className="list-disc list-inside space-y-1 text-sm">
                          <li>Il paziente arriva in struttura il giorno dell'appuntamento</li>
                          <li>Si presenta all'Admin/Reception</li>
                          <li>L'Admin visualizza nella sezione "Check-in Oggi" la lista dei pazienti prenotati</li>
                        </ul>
                      </div>
                      <div className="bg-green-50 rounded-xl p-4">
                        <h4 className="font-semibold text-green-800 mb-2">B) Effettuazione Check-in</h4>
                        <ul className="list-disc list-inside space-y-1 text-sm">
                          <li>Il paziente scansiona la <strong>Patient Card</strong> (QR code) oppure l'Admin cerca manualmente</li>
                          <li>L'Admin clicca "Effettua Check-in"</li>
                          <li>Se c'è un pagamento: il paziente paga (Stripe/contanti)</li>
                          <li>Dopo il check-in il paziente entra in <strong>Sala d'Attesa</strong></li>
                        </ul>
                      </div>
                      <div className="bg-green-50 rounded-xl p-4">
                        <h4 className="font-semibold text-green-800 mb-2">C) Stati del Paziente</h4>
                        <div className="grid grid-cols-2 gap-2 mt-2">
                          <div className="px-3 py-2 bg-yellow-100 rounded-lg text-yellow-800 text-center">📋 Prenotato</div>
                          <div className="px-3 py-2 bg-blue-100 rounded-lg text-blue-800 text-center">✅ Check-in effettuato</div>
                          <div className="px-3 py-2 bg-orange-100 rounded-lg text-orange-800 text-center">🪑 In Sala d'Attesa</div>
                          <div className="px-3 py-2 bg-purple-100 rounded-lg text-purple-800 text-center">📢 Chiamato in Stanza X</div>
                          <div className="px-3 py-2 bg-green-100 rounded-lg text-green-800 text-center col-span-2">✔️ Visita Completata</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Iter Chiamata Paziente */}
                  <div className="bg-white rounded-2xl p-6 shadow-sm border-l-4 border-purple-500">
                    <h3 className="text-xl font-bold text-purple-700 mb-4 flex items-center gap-2">
                      📢 3. ITER CHIAMATA PAZIENTE
                    </h3>
                    <div className="space-y-4 text-gray-700">
                      <div className="bg-purple-50 rounded-xl p-4">
                        <h4 className="font-semibold text-purple-800 mb-2">A) Il Medico Chiama</h4>
                        <ul className="list-disc list-inside space-y-1 text-sm">
                          <li>Il medico dalla sua Dashboard vede i pazienti in Sala d'Attesa</li>
                          <li>Clicca "<strong>Chiama Paziente</strong>"</li>
                          <li>Seleziona la <strong>Stanza</strong> (A, B, C, D...)</li>
                          <li>Il sistema invia una <strong>notifica all'Admin</strong></li>
                        </ul>
                      </div>
                      <div className="bg-purple-50 rounded-xl p-4">
                        <h4 className="font-semibold text-purple-800 mb-2">B) Notifica all'Admin</h4>
                        <div className="bg-white border rounded-lg p-3 mt-2">
                          <p className="text-sm">🔔 <strong>Notifica:</strong></p>
                          <p className="text-lg font-semibold text-purple-700">"Dr. Rossi ha chiamato Mario Bianchi in Stanza A"</p>
                        </div>
                      </div>
                      <div className="bg-purple-50 rounded-xl p-4">
                        <h4 className="font-semibold text-purple-800 mb-2">C) Accompagnamento</h4>
                        <ul className="list-disc list-inside space-y-1 text-sm">
                          <li>L'Admin visualizza la notifica in tempo reale</li>
                          <li>Accompagna <strong>personalmente</strong> il paziente nella stanza indicata</li>
                          <li>Lo stato del paziente diventa "In Visita"</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  {/* Iter Conclusione Visita */}
                  <div className="bg-white rounded-2xl p-6 shadow-sm border-l-4 border-orange-500">
                    <h3 className="text-xl font-bold text-orange-700 mb-4 flex items-center gap-2">
                      ✅ 4. ITER CONCLUSIONE VISITA
                    </h3>
                    <div className="space-y-4 text-gray-700">
                      <div className="bg-orange-50 rounded-xl p-4">
                        <h4 className="font-semibold text-orange-800 mb-2">A) Fine della Visita</h4>
                        <ul className="list-disc list-inside space-y-1 text-sm">
                          <li>Il medico compila la <strong>Cartella Clinica</strong></li>
                          <li>Inserisce diagnosi, terapia, consigli</li>
                          <li>Clicca "<strong>Concludi Visita</strong>"</li>
                          <li>Inserisce la <strong>Firma Digitale OTP</strong> per confermare</li>
                        </ul>
                      </div>
                      <div className="bg-orange-50 rounded-xl p-4">
                        <h4 className="font-semibold text-orange-800 mb-2">B) Documenti per il Paziente</h4>
                        <ul className="list-disc list-inside space-y-1 text-sm">
                          <li>Il paziente può scaricare la <strong>Cartella Clinica in PDF</strong></li>
                          <li>Può visualizzare prescrizioni e terapie nell'app</li>
                          <li>Riceve promemoria per il prossimo controllo</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  {/* Abbonamenti */}
                  <div className="bg-white rounded-2xl p-6 shadow-sm border-l-4 border-amber-500">
                    <h3 className="text-xl font-bold text-amber-700 mb-4 flex items-center gap-2">
                      💳 RIEPILOGO ABBONAMENTI
                    </h3>
                    <div className="grid md:grid-cols-2 gap-4">
                      <div className="bg-gradient-to-br from-gray-100 to-gray-200 rounded-xl p-4 border">
                        <h4 className="font-bold text-gray-800 mb-2">🥈 BASE - €29/mese</h4>
                        <ul className="text-sm space-y-1">
                          <li>✅ 1 visita gratuita/anno</li>
                          <li>✅ 20% sconto su prestazioni diagnostiche</li>
                          <li>✅ Priorità prenotazione</li>
                          <li>❌ Servizio autista non incluso</li>
                        </ul>
                      </div>
                      <div className="bg-gradient-to-br from-amber-100 to-amber-200 rounded-xl p-4 border border-amber-300">
                        <h4 className="font-bold text-amber-800 mb-2">💎 PREMIUM - €79/mese</h4>
                        <ul className="text-sm space-y-1">
                          <li>✅ Visite illimitate</li>
                          <li>✅ Tutte le prestazioni diagnostiche incluse</li>
                          <li>✅ 3 IVT/anno incluse</li>
                          <li>✅ <strong>Servizio Autista GRATUITO</strong></li>
                          <li>✅ Priorità assoluta</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  {/* Note per Admin */}
                  <div className="bg-red-50 rounded-2xl p-6 border border-red-200">
                    <h3 className="text-lg font-bold text-red-700 mb-3">⚠️ NOTE IMPORTANTI PER L'ADMIN</h3>
                    <ul className="list-disc list-inside space-y-2 text-red-800 text-sm">
                      <li>Controllare sempre lo <strong>stato dell'abbonamento</strong> prima del check-in</li>
                      <li>Verificare che il <strong>pagamento</strong> sia completato prima di far accomodare in sala d'attesa</li>
                      <li>Le <strong>notifiche di chiamata</strong> sono in tempo reale - rispondere prontamente</li>
                      <li>In caso di problemi tecnici, contattare il supporto</li>
                    </ul>
                  </div>
                </div>
              )}

              {/* Reviews Tab */}
              {activeTab === 'reviews' && (
                <ReviewsManagementTab />
              )}
            </>
          )}
        </div>
      </div>

      {/* Edit/Create Appointment Modal */}
      {editAppointmentModal.show && editAppointmentModal.appointment && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl max-w-lg w-full max-h-[90vh] overflow-y-auto">
            {/* Header */}
            <div className="p-6 border-b sticky top-0 bg-gradient-to-r from-[#2A9FCB] to-[#2A9FCB] rounded-t-2xl">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-xl font-bold text-white">
                    {editAppointmentModal.isNew ? '➕ Nuovo Appuntamento' : '✏️ Modifica Appuntamento'}
                  </h3>
                  <p className="text-white/80 text-sm">
                    {editAppointmentModal.isNew 
                      ? 'Crea appuntamento per un paziente'
                      : editAppointmentModal.appointment.patient_name
                    }
                  </p>
                </div>
                <button 
                  onClick={() => {
                    setEditAppointmentModal({ show: false, appointment: null });
                    setAvailableSlots([]);
                    setPatientSearchQuery('');
                    setPatientSearchResults([]);
                  }}
                  className="p-2 hover:bg-white/20 rounded-lg text-white"
                >
                  <X className="w-5 h-5" />
                </button>
              </div>
            </div>
            
            {/* Content */}
            <div className="p-6 space-y-5">
              {/* Patient Selection (only for new appointments) */}
              {editAppointmentModal.isNew && (
                <div className="bg-amber-50 rounded-xl p-4 border border-amber-200">
                  <h4 className="font-semibold text-amber-800 mb-3 flex items-center gap-2">
                    <Users className="w-4 h-4" /> Paziente *
                  </h4>
                  {editAppointmentModal.selectedPatient ? (
                    <div className="flex items-center justify-between bg-white p-3 rounded-lg border">
                      <div>
                        <p className="font-medium">{editAppointmentModal.selectedPatient.first_name} {editAppointmentModal.selectedPatient.last_name}</p>
                        <p className="text-sm text-gray-500">{editAppointmentModal.selectedPatient.email}</p>
                      </div>
                      <button
                        onClick={() => setEditAppointmentModal(prev => ({...prev, selectedPatient: null}))}
                        className="p-1 hover:bg-gray-100 rounded"
                      >
                        <X className="w-4 h-4 text-gray-500" />
                      </button>
                    </div>
                  ) : (
                    <div className="relative">
                      <input
                        type="text"
                        placeholder="Cerca paziente per nome o email..."
                        value={patientSearchQuery}
                        onChange={(e) => {
                          setPatientSearchQuery(e.target.value);
                          searchPatients(e.target.value);
                        }}
                        className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-amber-400"
                      />
                      {searchingPatients && (
                        <div className="absolute right-3 top-2.5">
                          <Loader2 className="w-5 h-5 animate-spin text-amber-500" />
                        </div>
                      )}
                      {patientSearchResults.length > 0 && (
                        <div className="absolute z-10 w-full mt-1 bg-white border rounded-lg shadow-lg max-h-48 overflow-y-auto">
                          {patientSearchResults.map(p => (
                            <button
                              key={p.id}
                              onClick={() => {
                                setEditAppointmentModal(prev => ({...prev, selectedPatient: p}));
                                setPatientSearchQuery('');
                                setPatientSearchResults([]);
                              }}
                              className="w-full px-4 py-2 text-left hover:bg-amber-50 border-b last:border-b-0"
                            >
                              <p className="font-medium">{p.first_name} {p.last_name}</p>
                              <p className="text-xs text-gray-500">{p.email}</p>
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                  
                  {/* Inserisci Nuovo Paziente button */}
                  <button
                    type="button"
                    onClick={() => navigate('/admin?tab=pazienti&action=new')}
                    className="mt-3 w-full flex items-center justify-center gap-2 px-4 py-2 bg-amber-100 hover:bg-amber-200 text-amber-800 rounded-lg transition-colors text-sm font-medium"
                    data-testid="insert-new-patient-btn"
                  >
                    <UserPlus className="w-4 h-4" />
                    Inserisci Nuovo Paziente
                  </button>
                </div>
              )}
              
              {/* Sede */}
              <div className="bg-gray-50 rounded-xl p-4 border border-gray-200">
                <h4 className="font-semibold text-gray-800 mb-3 flex items-center gap-2">
                  <MapPin className="w-4 h-4" /> Sede {editAppointmentModal.isNew && '*'}
                </h4>
                <div className="grid grid-cols-2 gap-3">
                  <button
                    type="button"
                    onClick={() => setEditAppointmentModal(prev => ({...prev, newLocation: 'milano'}))}
                    className={`p-3 rounded-lg border-2 transition-all flex items-center justify-center gap-2 font-medium ${
                      editAppointmentModal.newLocation === 'milano'
                        ? 'border-orange-500 bg-orange-50 text-orange-700'
                        : 'border-gray-200 hover:border-gray-300'
                    }`}
                    data-testid="admin-location-milano"
                  >
                    <MapPin className="w-4 h-4" />
                    Milano
                  </button>
                  <button
                    type="button"
                    onClick={() => setEditAppointmentModal(prev => ({...prev, newLocation: 'napoli'}))}
                    className={`p-3 rounded-lg border-2 transition-all flex items-center justify-center gap-2 font-medium ${
                      editAppointmentModal.newLocation === 'napoli'
                        ? 'border-blue-500 bg-blue-50 text-blue-700'
                        : 'border-gray-200 hover:border-gray-300'
                    }`}
                    data-testid="admin-location-napoli"
                  >
                    <MapPin className="w-4 h-4" />
                    Napoli
                  </button>
                </div>
              </div>
              
              {/* Medico */}
              <div className="bg-green-50 rounded-xl p-4 border border-green-200">
                <h4 className="font-semibold text-green-800 mb-3 flex items-center gap-2">
                  🩺 Medico {editAppointmentModal.isNew && '*'}
                </h4>
                <select
                  value={editAppointmentModal.newDoctorId || ''}
                  onChange={(e) => {
                    setEditAppointmentModal(prev => ({...prev, newDoctorId: e.target.value}));
                    if (editAppointmentModal.isNew && editAppointmentModal.newDate) {
                      loadAvailableSlots(e.target.value, editAppointmentModal.newDate);
                    }
                  }}
                  className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-green-400 bg-white"
                >
                  <option value="">Seleziona medico...</option>
                  {doctors.map(doc => (
                    <option key={doc.id} value={doc.id}>
                      Dr. {doc.first_name} {doc.last_name} {doc.role === 'ortottista' ? '(Ortottista)' : '(Oculista)'}
                    </option>
                  ))}
                </select>
              </div>
              
              {/* Data e Ora */}
              <div className="bg-blue-50 rounded-xl p-4 border border-blue-200">
                <h4 className="font-semibold text-blue-800 mb-3 flex items-center gap-2">
                  <Calendar className="w-4 h-4" /> Data e Ora {editAppointmentModal.isNew && '*'}
                </h4>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium mb-1 text-gray-700">Data</label>
                    <input
                      type="date"
                      value={editAppointmentModal.newDate || ''}
                      min={new Date().toISOString().split('T')[0]}
                      onChange={(e) => {
                        setEditAppointmentModal(prev => ({...prev, newDate: e.target.value, newTime: ''}));
                        if (editAppointmentModal.isNew && editAppointmentModal.newDoctorId) {
                          loadAvailableSlots(editAppointmentModal.newDoctorId, e.target.value);
                        }
                      }}
                      className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-400"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-1 text-gray-700">Orario</label>
                    {editAppointmentModal.isNew ? (
                      <div>
                        {loadingSlots ? (
                          <div className="flex items-center gap-2 px-3 py-2 text-gray-500">
                            <Loader2 className="w-4 h-4 animate-spin" />
                            Caricamento...
                          </div>
                        ) : availableSlots.length > 0 ? (
                          <select
                            value={editAppointmentModal.newTime || ''}
                            onChange={(e) => setEditAppointmentModal(prev => ({...prev, newTime: e.target.value}))}
                            className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-400 bg-white"
                          >
                            <option value="">Seleziona orario...</option>
                            {availableSlots.map(slot => (
                              <option key={slot.time} value={slot.time}>
                                {slot.time} ({slot.period === 'morning' ? 'Mattina' : 'Pomeriggio'})
                              </option>
                            ))}
                          </select>
                        ) : editAppointmentModal.newDoctorId && editAppointmentModal.newDate ? (
                          <p className="text-sm text-red-500 px-2 py-2">Nessuno slot disponibile</p>
                        ) : (
                          <p className="text-sm text-gray-500 px-2 py-2">Seleziona medico e data</p>
                        )}
                      </div>
                    ) : (
                      <input
                        type="time"
                        value={editAppointmentModal.newTime || ''}
                        onChange={(e) => setEditAppointmentModal(prev => ({...prev, newTime: e.target.value}))}
                        className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-400"
                      />
                    )}
                  </div>
                </div>
              </div>
              
              {/* Motivo (for new appointments) */}
              {editAppointmentModal.isNew && (
                <div className="bg-gray-50 rounded-xl p-4 border border-gray-200">
                  <h4 className="font-semibold text-gray-700 mb-3 flex items-center gap-2">
                    📋 Motivo della visita
                  </h4>
                  <input
                    type="text"
                    placeholder="Es: Visita di controllo, Prescrizione lenti..."
                    value={editAppointmentModal.appointment?.reason || ''}
                    onChange={(e) => setEditAppointmentModal(prev => ({
                      ...prev, 
                      appointment: {...prev.appointment, reason: e.target.value}
                    }))}
                    className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-gray-400"
                  />
                </div>
              )}
              
              {/* Stato (only for existing appointments) */}
              {!editAppointmentModal.isNew && (
                <div className="bg-purple-50 rounded-xl p-4 border border-purple-200">
                  <h4 className="font-semibold text-purple-800 mb-3 flex items-center gap-2">
                    📊 Stato Appuntamento
                  </h4>
                  <div className="grid grid-cols-2 gap-2">
                    {[
                      { value: 'scheduled', label: '📅 Programmato', color: 'yellow' },
                      { value: 'confirmed', label: '✅ Confermato', color: 'blue' },
                      { value: 'in_progress', label: '⏳ In corso', color: 'purple' },
                      { value: 'completed', label: '✔️ Completato', color: 'green' },
                      { value: 'cancelled', label: '❌ Cancellato', color: 'red' },
                    ].map(status => (
                      <button
                        key={status.value}
                        onClick={() => setEditAppointmentModal(prev => ({...prev, newStatus: status.value}))}
                        className={`px-3 py-2 rounded-lg text-sm font-medium border-2 transition-all ${
                          editAppointmentModal.newStatus === status.value
                            ? `border-${status.color}-500 bg-${status.color}-100 text-${status.color}-700`
                            : 'border-gray-200 hover:border-gray-300'
                        }`}
                      >
                        {status.label}
                      </button>
                    ))}
                  </div>
                </div>
              )}
              
              {/* Info originali (only for existing appointments) */}
              {!editAppointmentModal.isNew && (
                <div className="bg-gray-50 rounded-xl p-4 text-sm text-gray-600">
                  <p><strong>Originale:</strong></p>
                  <p>📅 {editAppointmentModal.appointment.date} alle {editAppointmentModal.appointment.time}</p>
                  <p>🩺 {editAppointmentModal.appointment.doctor_name || 'Non assegnato'}</p>
                  <p>📋 {editAppointmentModal.appointment.reason || editAppointmentModal.appointment.service_type || 'Visita'}</p>
                </div>
              )}
            </div>
            
            {/* Footer */}
            <div className="p-6 border-t sticky bottom-0 bg-white rounded-b-2xl">
              <div className="flex gap-3">
                <button
                  onClick={() => {
                    setEditAppointmentModal({ show: false, appointment: null });
                    setAvailableSlots([]);
                    setPatientSearchQuery('');
                    setPatientSearchResults([]);
                  }}
                  className="flex-1 px-4 py-3 rounded-lg border border-gray-200 text-gray-700 font-medium hover:bg-gray-50"
                >
                  Annulla
                </button>
                <button
                  onClick={editAppointmentModal.isNew ? createNewAppointment : saveAppointmentChanges}
                  disabled={savingAppointment || (editAppointmentModal.isNew && (!editAppointmentModal.selectedPatient || !editAppointmentModal.newDoctorId || !editAppointmentModal.newDate || !editAppointmentModal.newTime))}
                  className="flex-1 px-4 py-3 rounded-lg text-white font-medium flex items-center justify-center gap-2 disabled:opacity-50"
                  style={{background: '#2A9FCB'}}
                >
                  {savingAppointment ? (
                    <Loader2 className="w-5 h-5 animate-spin" />
                  ) : (
                    <>
                      <Check className="w-5 h-5" />
                      {editAppointmentModal.isNew ? 'Crea Appuntamento' : 'Salva Modifiche'}
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Add Doctor Modal */}
      {showAddDoctorModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl max-w-md w-full p-6">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-xl font-bold" style={{color: '#2A9FCB'}}>Nuovo Staff Medico</h3>
              <button 
                onClick={() => setShowAddDoctorModal(false)}
                className="p-2 hover:bg-gray-100 rounded-lg"
              >
                <XCircle className="w-5 h-5" />
              </button>
            </div>

            <div className="space-y-4">
              {/* Tipo di Staff */}
              <div>
                <label className="block text-sm font-medium mb-2 text-[#2A9FCB]">Tipo di Staff *</label>
                <div className="flex gap-4">
                  <label className={`flex-1 flex items-center gap-3 p-3 rounded-lg border-2 cursor-pointer transition-all ${
                    newDoctorForm.staff_type === 'doctor' ? 'border-emerald-500 bg-emerald-50' : 'border-gray-200 hover:border-emerald-200'
                  }`}>
                    <input
                      type="radio"
                      name="staff_type"
                      value="doctor"
                      checked={newDoctorForm.staff_type === 'doctor'}
                      onChange={(e) => setNewDoctorForm({...newDoctorForm, staff_type: e.target.value})}
                      className="text-emerald-600"
                    />
                    <div>
                      <span className="font-medium text-emerald-700">🩺 Oculista</span>
                      <p className="text-xs text-gray-500">Medico specializzato</p>
                    </div>
                  </label>
                  <label className={`flex-1 flex items-center gap-3 p-3 rounded-lg border-2 cursor-pointer transition-all ${
                    newDoctorForm.staff_type === 'ortottista' ? 'border-purple-500 bg-purple-50' : 'border-gray-200 hover:border-purple-200'
                  }`}>
                    <input
                      type="radio"
                      name="staff_type"
                      value="ortottista"
                      checked={newDoctorForm.staff_type === 'ortottista'}
                      onChange={(e) => setNewDoctorForm({...newDoctorForm, staff_type: e.target.value})}
                      className="text-purple-600"
                    />
                    <div>
                      <span className="font-medium text-purple-700">👁️ Ortottista</span>
                      <p className="text-xs text-gray-500">Specialista ortottica</p>
                    </div>
                  </label>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium mb-1 text-[#2A9FCB]">Nome *</label>
                  <input
                    type="text"
                    value={newDoctorForm.first_name}
                    onChange={(e) => setNewDoctorForm({...newDoctorForm, first_name: e.target.value})}
                    className="w-full px-3 py-2 border rounded-lg"
                    placeholder="Nome"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1 text-[#2A9FCB]">Cognome *</label>
                  <input
                    type="text"
                    value={newDoctorForm.last_name}
                    onChange={(e) => setNewDoctorForm({...newDoctorForm, last_name: e.target.value})}
                    className="w-full px-3 py-2 border rounded-lg"
                    placeholder="Cognome"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium mb-1 text-[#2A9FCB]">Email *</label>
                <input
                  type="email"
                  value={newDoctorForm.email}
                  onChange={(e) => setNewDoctorForm({...newDoctorForm, email: e.target.value})}
                  className="w-full px-3 py-2 border rounded-lg"
                  placeholder="email@esempio.com"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1 text-[#2A9FCB]">Password *</label>
                <input
                  type="password"
                  value={newDoctorForm.password}
                  onChange={(e) => setNewDoctorForm({...newDoctorForm, password: e.target.value})}
                  className="w-full px-3 py-2 border rounded-lg"
                  placeholder="Password temporanea"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1 text-[#2A9FCB]">Telefono</label>
                <input
                  type="tel"
                  value={newDoctorForm.phone}
                  onChange={(e) => setNewDoctorForm({...newDoctorForm, phone: e.target.value})}
                  className="w-full px-3 py-2 border rounded-lg"
                  placeholder="+39 333 1234567"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1 text-[#2A9FCB]">Specializzazione</label>
                <input
                  type="text"
                  value={newDoctorForm.specialization}
                  onChange={(e) => setNewDoctorForm({...newDoctorForm, specialization: e.target.value})}
                  className="w-full px-3 py-2 border rounded-lg"
                  placeholder="Es: Chirurgia refrattiva, Glaucoma..."
                />
              </div>

              {/* Sedi di lavoro */}
              <div>
                <label className="block text-sm font-medium mb-2 text-[#2A9FCB]">Sedi di lavoro *</label>
                <div className="flex gap-3" data-testid="work-locations-selector">
                  <label className={`flex-1 flex items-center gap-2 p-3 rounded-lg border-2 cursor-pointer transition-all ${
                    newDoctorForm.work_locations?.includes('milano') ? 'border-orange-500 bg-orange-50' : 'border-gray-200 hover:border-orange-200'
                  }`}>
                    <input
                      type="checkbox"
                      checked={newDoctorForm.work_locations?.includes('milano') || false}
                      onChange={(e) => {
                        const locs = [...(newDoctorForm.work_locations || [])];
                        if (e.target.checked) {
                          if (!locs.includes('milano')) locs.push('milano');
                        } else {
                          const idx = locs.indexOf('milano');
                          if (idx > -1) locs.splice(idx, 1);
                        }
                        setNewDoctorForm({...newDoctorForm, work_locations: locs});
                      }}
                      className="accent-orange-500"
                    />
                    <div>
                      <span className="font-medium text-orange-700 text-sm">Milano</span>
                      <p className="text-xs text-gray-400">Via Santa Sofia 10</p>
                    </div>
                  </label>
                  <label className={`flex-1 flex items-center gap-2 p-3 rounded-lg border-2 cursor-pointer transition-all ${
                    newDoctorForm.work_locations?.includes('napoli') ? 'border-sky-500 bg-sky-50' : 'border-gray-200 hover:border-sky-200'
                  }`}>
                    <input
                      type="checkbox"
                      checked={newDoctorForm.work_locations?.includes('napoli') || false}
                      onChange={(e) => {
                        const locs = [...(newDoctorForm.work_locations || [])];
                        if (e.target.checked) {
                          if (!locs.includes('napoli')) locs.push('napoli');
                        } else {
                          const idx = locs.indexOf('napoli');
                          if (idx > -1) locs.splice(idx, 1);
                        }
                        setNewDoctorForm({...newDoctorForm, work_locations: locs});
                      }}
                      className="accent-sky-500"
                    />
                    <div>
                      <span className="font-medium text-sky-700 text-sm">Napoli</span>
                      <p className="text-xs text-gray-400">Via Posillipo 168</p>
                    </div>
                  </label>
                </div>
              </div>
            </div>

            <div className="flex gap-3 mt-6">
              <button
                onClick={() => setShowAddDoctorModal(false)}
                className="flex-1 py-3 rounded-lg border font-medium"
                style={{borderColor: '#E5E7EB', color: '#2A9FCB'}}
              >
                Annulla
              </button>
              <button
                onClick={handleCreateDoctor}
                disabled={addingDoctor}
                className="flex-1 py-3 rounded-lg font-medium text-white flex items-center justify-center gap-2"
                style={{background: addingDoctor ? '#9EC5B5' : '#2A9FCB'}}
              >
                {addingDoctor ? (
                  <>
                    <Loader2 className="w-5 h-5 animate-spin" />
                    Creazione...
                  </>
                ) : (
                  <>
                    <UserPlus className="w-5 h-5" />
                    Crea {newDoctorForm.staff_type === 'ortottista' ? 'Ortottista' : 'Oculista'}
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* Modal Aggiungi Paziente - componente separato per maggiore stabilità */}
      <AddPatientModal
        isOpen={showAddPatientModal}
        onClose={() => setShowAddPatientModal(false)}
        onPatientAdded={() => loadData()}
      />

      {/* Modal Dettagli Statistiche */}
      {statsDetailModal.show && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl w-full max-w-3xl max-h-[80vh] flex flex-col shadow-2xl overflow-hidden">
            {/* Header */}
            <div className="p-6 border-b bg-gradient-to-r from-[#2A9FCB] to-[#1E7BA8] flex items-center justify-between">
              <h2 className="text-xl font-bold text-white">{statsDetailModal.title}</h2>
              <button 
                onClick={() => setStatsDetailModal({ show: false, type: null, title: '', data: [] })}
                className="text-white hover:bg-white/20 p-2 rounded-lg transition-colors"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
            
            {/* Content */}
            <div className="flex-1 overflow-y-auto p-6">
              {loadingStatsDetail ? (
                <div className="flex items-center justify-center py-12">
                  <Loader2 className="w-8 h-8 animate-spin text-[#2A9FCB]" />
                </div>
              ) : statsDetailModal.data.length === 0 ? (
                <div className="text-center py-12 text-gray-500">
                  <Users className="w-16 h-16 mx-auto mb-4 text-gray-300" />
                  <p>Nessun dato disponibile</p>
                </div>
              ) : (
                <div className="space-y-3">
                  {/* Appointments */}
                  {statsDetailModal.type?.includes('appointments') && statsDetailModal.data.map((item, idx) => (
                    <div key={idx} className="p-4 rounded-xl border border-gray-200 hover:border-[#2A9FCB] hover:shadow-md transition-all">
                      <div className="flex items-center justify-between mb-2">
                        <div className="flex items-center gap-3">
                          <div className="w-10 h-10 rounded-full bg-[#2A9FCB]/10 flex items-center justify-center">
                            <User className="w-5 h-5 text-[#2A9FCB]" />
                          </div>
                          <div>
                            <p className="font-semibold text-gray-800">{item.patient_name}</p>
                            <p className="text-sm text-gray-500">{item.service_type || 'Visita Oculistica'}</p>
                          </div>
                        </div>
                        <div className="text-right">
                          <p className="font-medium text-[#2A9FCB]">{new Date(item.appointment_date).toLocaleDateString('it-IT')}</p>
                          <p className="text-sm text-gray-500">{item.time || new Date(item.appointment_date).toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' })}</p>
                        </div>
                      </div>
                      {item.doctor_name && (
                        <p className="text-xs text-gray-400 mt-2">Medico: {item.doctor_name}</p>
                      )}
                    </div>
                  ))}

                  {/* Patients */}
                  {(statsDetailModal.type?.includes('patients') || statsDetailModal.type?.includes('subscriptions')) && statsDetailModal.data.map((item, idx) => (
                    <div 
                      key={idx} 
                      className="p-4 rounded-xl border border-gray-200 hover:border-[#2A9FCB] hover:shadow-md transition-all cursor-pointer"
                      onClick={() => {
                        setStatsDetailModal({ show: false, type: null, title: '', data: [] });
                        navigate(`/cartella-clinica/${item.id}`);
                      }}
                    >
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-3">
                          <div className="relative">
                            <div className="w-10 h-10 rounded-full bg-emerald-100 flex items-center justify-center">
                              <User className="w-5 h-5 text-emerald-600" />
                            </div>
                            {/* Subscription Icon Overlay */}
                            {item.subscription_tier === 'PREMIUM' && (
                              <div className="absolute -top-1 -right-1 w-5 h-5 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full flex items-center justify-center shadow-sm" title="Premium">
                                <span className="text-[10px]">👑💎</span>
                              </div>
                            )}
                            {item.subscription_tier === 'BASE' && (
                              <div className="absolute -top-1 -right-1 w-5 h-5 bg-gradient-to-br from-amber-300 to-yellow-400 rounded-full flex items-center justify-center shadow-sm" title="Base">
                                <span className="text-[10px]">👑</span>
                              </div>
                            )}
                          </div>
                          <div>
                            <p className="font-semibold text-gray-800">{item.first_name} {item.last_name}</p>
                            <p className="text-sm text-gray-500">{item.email}</p>
                          </div>
                        </div>
                        <div className="text-right flex flex-col items-end gap-1">
                          {item.phone && <p className="text-sm text-gray-600">{item.phone}</p>}
                          {/* Activity Tag Badge */}
                          {item.activity_tag && (
                            <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${
                              item.activity_tag === 'LEAD' ? 'bg-red-100 text-red-700 border border-red-200' :
                              item.activity_tag === 'NAIVE' ? 'bg-yellow-100 text-yellow-700 border border-yellow-200' :
                              item.activity_tag === 'FIDELIZZATO' ? 'bg-green-100 text-green-700 border border-green-200' :
                              item.activity_tag === 'DORMIENTE' ? 'bg-gray-100 text-gray-600 border border-gray-200' :
                              'bg-gray-100 text-gray-600'
                            }`}>
                              {item.activity_tag}
                            </span>
                          )}
                          {item.subscription_type && (
                            <span className="text-xs px-2 py-1 rounded-full bg-amber-100 text-amber-700 font-medium">
                              {item.subscription_type}
                            </span>
                          )}
                          {item.registered_at && (
                            <p className="text-xs text-gray-400 mt-1">
                              Registrato: {new Date(item.registered_at).toLocaleDateString('it-IT')}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}

                  {/* Services Stats */}
                  {statsDetailModal.type === 'top_services' && statsDetailModal.data.map((item, idx) => (
                    <div key={idx} className="p-4 rounded-xl border border-gray-200 flex items-center justify-between">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center text-lg font-bold text-purple-600">
                          {idx + 1}
                        </div>
                        <div>
                          <p className="font-semibold text-gray-800">{item.service_name}</p>
                          <p className="text-sm text-gray-500">{item.category || 'Visita'}</p>
                        </div>
                      </div>
                      <div className="text-right">
                        <p className="text-2xl font-bold text-purple-600">{item.count}</p>
                        <p className="text-xs text-gray-400">prenotazioni</p>
                      </div>
                    </div>
                  ))}

                  {/* Diagnosis/Tags */}
                  {statsDetailModal.type === 'patients_by_diagnosis' && statsDetailModal.data.map((item, idx) => (
                    <div key={idx} className="p-4 rounded-xl border border-gray-200">
                      <div className="flex items-center justify-between mb-3">
                        <div className="flex items-center gap-3">
                          <div className="w-10 h-10 rounded-full bg-rose-100 flex items-center justify-center">
                            <Eye className="w-5 h-5 text-rose-600" />
                          </div>
                          <div>
                            <p className="font-semibold text-gray-800">{item.diagnosis || item.tag}</p>
                          </div>
                        </div>
                        <span className="text-2xl font-bold text-rose-600">{item.patient_count}</span>
                      </div>
                      {item.patients && item.patients.length > 0 && (
                        <div className="mt-3 pt-3 border-t border-gray-100">
                          <p className="text-xs text-gray-500 mb-2">Pazienti:</p>
                          <div className="flex flex-wrap gap-2">
                            {item.patients.slice(0, 5).map((p, pIdx) => (
                              <span 
                                key={pIdx} 
                                onClick={() => {
                                  setStatsDetailModal({ show: false, type: null, title: '', data: [] });
                                  navigate(`/cartella-clinica/${p.id}`);
                                }}
                                className="text-xs px-2 py-1 rounded-full bg-gray-100 text-gray-700 hover:bg-[#2A9FCB] hover:text-white cursor-pointer transition-colors"
                              >
                                {p.name}
                              </span>
                            ))}
                            {item.patients.length > 5 && (
                              <span className="text-xs px-2 py-1 rounded-full bg-gray-200 text-gray-600">
                                +{item.patients.length - 5} altri
                              </span>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      
      {/* Messages Modal */}
      <InternalMessages 
        isOpen={showMessagesModal} 
        onClose={() => setShowMessagesModal(false)} 
        currentUser={user} 
      />
      
      {/* Create Invoice Modal */}
      {showCreateInvoiceModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-xl max-w-lg w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6 border-b sticky top-0 bg-white rounded-t-2xl">
              <div className="flex items-center justify-between">
                <h3 className="text-xl font-bold" style={{color: '#2A9FCB'}}>
                  <FileText className="w-5 h-5 inline mr-2" />
                  Emetti Nuova Fattura
                </h3>
                <button onClick={() => setShowCreateInvoiceModal(false)} className="p-2 hover:bg-gray-100 rounded-lg">
                  <X className="w-5 h-5" />
                </button>
              </div>
            </div>
            
            <div className="p-6 space-y-4">
              {/* Selezione Paziente */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Paziente *</label>
                <select
                  value={newInvoice.patient_id}
                  onChange={(e) => {
                    const patient = patients.find(p => p.id === e.target.value);
                    setNewInvoice({
                      ...newInvoice,
                      patient_id: e.target.value,
                      patient_name: patient ? `${patient.first_name} ${patient.last_name}` : ''
                    });
                  }}
                  className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-[#2A9FCB] focus:border-transparent"
                >
                  <option value="">-- Seleziona paziente --</option>
                  {patients.map(p => (
                    <option key={p.id} value={p.id}>
                      {p.first_name} {p.last_name} - {p.email}
                    </option>
                  ))}
                </select>
              </div>
              
              {/* Descrizione */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Descrizione</label>
                <input
                  type="text"
                  value={newInvoice.description}
                  onChange={(e) => setNewInvoice({...newInvoice, description: e.target.value})}
                  className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-[#2A9FCB] focus:border-transparent"
                  placeholder="Es. Visita oculistica completa"
                />
              </div>
              
              {/* Items */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Voci fattura</label>
                {newInvoice.items.map((item, idx) => (
                  <div key={idx} className="flex gap-2 mb-2">
                    <input
                      type="text"
                      value={item.description}
                      onChange={(e) => {
                        const items = [...newInvoice.items];
                        items[idx].description = e.target.value;
                        setNewInvoice({...newInvoice, items});
                      }}
                      className="flex-1 p-2 border rounded-lg text-sm"
                      placeholder="Descrizione voce"
                    />
                    <input
                      type="number"
                      value={item.amount}
                      onChange={(e) => {
                        const items = [...newInvoice.items];
                        items[idx].amount = parseFloat(e.target.value) || 0;
                        const total = items.reduce((sum, i) => sum + i.amount, 0);
                        setNewInvoice({...newInvoice, items, amount: total});
                      }}
                      className="w-24 p-2 border rounded-lg text-sm"
                      placeholder="€"
                    />
                    {newInvoice.items.length > 1 && (
                      <button
                        onClick={() => {
                          const items = newInvoice.items.filter((_, i) => i !== idx);
                          const total = items.reduce((sum, i) => sum + i.amount, 0);
                          setNewInvoice({...newInvoice, items, amount: total});
                        }}
                        className="p-2 text-red-500 hover:bg-red-50 rounded-lg"
                      >
                        <Trash2 className="w-4 h-4" />
                      </button>
                    )}
                  </div>
                ))}
                <button
                  onClick={() => setNewInvoice({
                    ...newInvoice,
                    items: [...newInvoice.items, { description: '', amount: 0 }]
                  })}
                  className="text-sm text-[#2A9FCB] hover:underline flex items-center gap-1"
                >
                  <Plus className="w-4 h-4" /> Aggiungi voce
                </button>
              </div>
              
              {/* Totale */}
              <div className="bg-gray-50 p-4 rounded-xl">
                <div className="flex justify-between items-center">
                  <span className="font-medium text-gray-700">Totale Fattura:</span>
                  <span className="text-2xl font-bold" style={{color: '#2A9FCB'}}>
                    €{newInvoice.amount.toFixed(2)}
                  </span>
                </div>
              </div>
            </div>
            
            <div className="p-6 border-t flex gap-3">
              <button
                onClick={() => setShowCreateInvoiceModal(false)}
                className="flex-1 py-3 border rounded-xl font-medium hover:bg-gray-50"
              >
                Annulla
              </button>
              <button
                onClick={createInvoice}
                className="flex-1 py-3 rounded-xl font-medium text-white"
                style={{background: 'linear-gradient(135deg, #2A9FCB 0%, #1E8AB8 100%)'}}
              >
                Emetti Fattura
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// Protocols Management Tab Component
const ProtocolsManagementTab = ({ patients, API }) => {
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [showPrescribeModal, setShowPrescribeModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [prescribedProtocols, setPrescribedProtocols] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pathologies, setPathologies] = useState([]);

  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => {
    loadPathologies();
  }, []);

  const loadPathologies = async () => {
    try {
      const res = await axios.get(`${API}/prevention/pathologies-list`);
      setPathologies(res.data.pathologies || []);
    } catch (error) {
      console.error('Error loading pathologies:', error);
    }
  };

  const loadPatientProtocols = async (patientId) => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/prevention/patient/${patientId}/protocols`, { headers });
      setPrescribedProtocols(res.data.protocols || []);
    } catch (error) {
      console.error('Error loading protocols:', error);
      setPrescribedProtocols([]);
    } finally {
      setLoading(false);
    }
  };

  const handlePatientSelect = (patient) => {
    setSelectedPatient(patient);
    loadPatientProtocols(patient.id);
  };

  const filteredPatients = patients.filter(p => {
    if (!searchQuery) return true;
    const search = searchQuery.toLowerCase();
    return (
      p.first_name?.toLowerCase().includes(search) ||
      p.last_name?.toLowerCase().includes(search) ||
      p.email?.toLowerCase().includes(search)
    );
  });

  const getPriorityBadge = (priority) => {
    const colors = {
      alta: 'bg-red-100 text-red-700',
      media: 'bg-yellow-100 text-yellow-700',
      bassa: 'bg-green-100 text-green-700'
    };
    return colors[priority] || colors.media;
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="bg-gradient-to-r from-[#2A9FCB] to-[#1C729E] rounded-xl p-6 text-white">
        <div className="flex items-center gap-3 mb-2">
          <Shield className="w-8 h-8" />
          <h2 className="text-2xl font-bold font-['Playfair_Display']">Protocolli di Prevenzione</h2>
        </div>
        <p className="text-white/80">Prescrivi protocolli personalizzati ai pazienti</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Patient List */}
        <div className="bg-white rounded-xl shadow-sm p-4">
          <div className="mb-4">
            <div className="relative">
              <input
                type="text"
                placeholder="Cerca paziente..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full pl-10 pr-4 py-2 border rounded-lg focus:ring-2 focus:ring-[#2A9FCB]/30"
              />
              <Users className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
            </div>
          </div>
          
          <div className="space-y-2 max-h-[500px] overflow-y-auto">
            {filteredPatients.slice(0, 50).map(patient => (
              <button
                key={patient.id}
                onClick={() => handlePatientSelect(patient)}
                className={`w-full text-left p-3 rounded-lg transition-all ${
                  selectedPatient?.id === patient.id 
                    ? 'bg-[#2A9FCB] text-white' 
                    : 'hover:bg-gray-50'
                }`}
              >
                <p className="font-medium">{patient.first_name} {patient.last_name}</p>
                <p className={`text-sm ${selectedPatient?.id === patient.id ? 'text-white/70' : 'text-gray-500'}`}>
                  {patient.email}
                </p>
              </button>
            ))}
          </div>
        </div>

        {/* Patient Details & Protocols */}
        <div className="lg:col-span-2 space-y-4">
          {selectedPatient ? (
            <>
              {/* Patient Info */}
              <div className="bg-white rounded-xl shadow-sm p-6">
                <div className="flex items-center justify-between mb-4">
                  <div>
                    <h3 className="text-xl font-bold text-[#2A9FCB]">
                      {selectedPatient.first_name} {selectedPatient.last_name}
                    </h3>
                    <p className="text-gray-500">{selectedPatient.email}</p>
                  </div>
                  <button
                    onClick={() => setShowPrescribeModal(true)}
                    className="flex items-center gap-2 px-4 py-2 bg-[#2A9FCB] text-white rounded-lg hover:bg-[#238bb3] transition-colors"
                  >
                    <Shield className="w-4 h-4" />
                    Prescrivi Protocollo
                  </button>
                </div>
              </div>

              {/* Prescribed Protocols */}
              <div className="bg-white rounded-xl shadow-sm p-6">
                <h4 className="font-semibold text-[#2A9FCB] mb-4 flex items-center gap-2">
                  <FileText className="w-5 h-5" />
                  Protocolli Prescritti ({prescribedProtocols.length})
                </h4>
                
                {loading ? (
                  <div className="flex items-center justify-center py-8">
                    <Loader2 className="w-6 h-6 animate-spin text-[#2A9FCB]" />
                  </div>
                ) : prescribedProtocols.length === 0 ? (
                  <div className="text-center py-8 text-gray-500">
                    <Shield className="w-12 h-12 mx-auto mb-3 text-gray-300" />
                    <p>Nessun protocollo prescritto</p>
                    <p className="text-sm">Clicca "Prescrivi Protocollo" per iniziare</p>
                  </div>
                ) : (
                  <div className="space-y-3">
                    {prescribedProtocols.map(protocol => (
                      <div key={protocol.id} className="border rounded-lg p-4">
                        <div className="flex items-center justify-between mb-2">
                          <h5 className="font-medium text-gray-800">{protocol.pathology_name}</h5>
                          <span className={`px-2 py-1 rounded-full text-xs font-medium ${getPriorityBadge(protocol.priority)}`}>
                            {protocol.priority}
                          </span>
                        </div>
                        <p className="text-sm text-gray-600 mb-2">{protocol.reason}</p>
                        <div className="flex items-center gap-4 text-xs text-gray-500">
                          <span className="flex items-center gap-1">
                            <Calendar className="w-3 h-3" />
                            {protocol.visit_frequency}
                          </span>
                          <span>
                            Prescritto: {new Date(protocol.prescribed_at).toLocaleDateString('it-IT')}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </>
          ) : (
            <div className="bg-white rounded-xl shadow-sm p-12 text-center">
              <Users className="w-16 h-16 mx-auto mb-4 text-gray-300" />
              <h3 className="text-lg font-medium text-gray-600 mb-2">Seleziona un paziente</h3>
              <p className="text-gray-500">Scegli un paziente dalla lista per visualizzare o prescrivere protocolli di prevenzione</p>
            </div>
          )}
        </div>
      </div>

      {/* Prescribe Modal */}
      {showPrescribeModal && selectedPatient && (
        <PrescribeProtocolForm
          patientId={selectedPatient.id}
          patientName={`${selectedPatient.first_name} ${selectedPatient.last_name}`}
          onClose={() => setShowPrescribeModal(false)}
          onSuccess={() => {
            loadPatientProtocols(selectedPatient.id);
            setShowPrescribeModal(false);
          }}
        />
      )}
    </div>
  );
};

// Subscriptions Tab Component
const SubscriptionsTab = ({ API_URL }) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [activeFilter, setActiveFilter] = useState('all');

  useEffect(() => {
    fetchSubscriptions();
  }, []);

  const fetchSubscriptions = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const res = await axios.get(`${API_URL}/admin/patients-by-subscription`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setData(res.data);
    } catch (err) {
      toast.error('Errore nel caricamento abbonamenti');
    } finally {
      setLoading(false);
    }
  };

  const getFilteredPatients = () => {
    if (!data) return [];
    switch (activeFilter) {
      case 'premium': return data.premium.patients;
      case 'base': return data.base.patients;
      case 'none': return data.none.patients;
      default: return [...data.premium.patients, ...data.base.patients, ...data.none.patients];
    }
  };

  if (loading) {
    return (
      <div className="rounded-2xl p-6 shadow-sm flex items-center justify-center py-12" style={{background: 'linear-gradient(135deg, #daeef9 0%, #f0f7fc 50%, #d4e8f5 100%)'}}>
        <Loader2 className="w-8 h-8 animate-spin text-[#2A9FCB]" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="rounded-2xl p-6 shadow-sm" style={{background: 'linear-gradient(135deg, #2A9FCB 0%, #2A9FCB 100%)'}}>
        <h2 className="text-2xl font-bold text-white">Gestione Abbonamenti</h2>
        <p className="text-white/80">Visualizza e gestisci gli abbonamenti dei pazienti</p>
      </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <button
          onClick={() => setActiveFilter('all')}
          className={`rounded-2xl p-5 shadow-sm text-left transition-all ${activeFilter === 'all' ? 'ring-2 ring-[#2A9FCB]' : ''}`}
          style={{background: 'linear-gradient(135deg, #daeef9 0%, #f0f7fc 50%, #d4e8f5 100%)'}}
        >
          <p className="text-sm text-[#2A9FCB]/70">Totale Pazienti</p>
          <p className="text-3xl font-bold text-[#2A9FCB]">{data?.total || 0}</p>
        </button>
        
        <button
          onClick={() => setActiveFilter('premium')}
          className={`rounded-2xl p-5 shadow-sm text-left transition-all ${activeFilter === 'premium' ? 'ring-2 ring-purple-500' : ''}`}
          style={{background: 'linear-gradient(135deg, #E9D5FF 0%, #F3E8FF 100%)'}}
        >
          <div className="flex items-center gap-2">
            <span className="text-xl">💎</span>
            <p className="text-sm text-purple-700">Premium</p>
          </div>
          <p className="text-3xl font-bold text-purple-700">{data?.premium?.count || 0}</p>
        </button>
        
        <button
          onClick={() => setActiveFilter('base')}
          className={`rounded-2xl p-5 shadow-sm text-left transition-all ${activeFilter === 'base' ? 'ring-2 ring-blue-500' : ''}`}
          style={{background: 'linear-gradient(135deg, #DBEAFE 0%, #dcedf8 100%)'}}
        >
          <div className="flex items-center gap-2">
            <span className="text-xl">🥈</span>
            <p className="text-sm text-blue-700">Base</p>
          </div>
          <p className="text-3xl font-bold text-blue-700">{data?.base?.count || 0}</p>
        </button>
        
        <button
          onClick={() => setActiveFilter('none')}
          className={`rounded-2xl p-5 shadow-sm text-left transition-all ${activeFilter === 'none' ? 'ring-2 ring-gray-500' : ''}`}
          style={{background: 'linear-gradient(135deg, #daeef9 0%, #f0f7fc 50%, #d4e8f5 100%)'}}
        >
          <div className="flex items-center gap-2">
            <span className="text-xl">📋</span>
            <p className="text-sm text-gray-600">Non Abbonati</p>
          </div>
          <p className="text-3xl font-bold text-gray-600">{data?.none?.count || 0}</p>
        </button>
      </div>

      {/* Patient List */}
      <div className="rounded-2xl p-6 shadow-sm" style={{background: 'linear-gradient(135deg, #daeef9 0%, #f0f7fc 50%, #d4e8f5 100%)'}}>
        <h3 className="text-lg font-bold mb-4 text-[#2A9FCB]">
          {activeFilter === 'all' && 'Tutti i Pazienti'}
          {activeFilter === 'premium' && '💎 Pazienti Premium'}
          {activeFilter === 'base' && '🥈 Pazienti Base'}
          {activeFilter === 'none' && '📋 Pazienti Non Abbonati'}
          <span className="text-sm font-normal text-[#2A9FCB]/60 ml-2">
            ({getFilteredPatients().length})
          </span>
        </h3>
        
        {getFilteredPatients().length === 0 ? (
          <p className="text-center text-[#2A9FCB]/60 py-8">Nessun paziente in questa categoria</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-[#2A9FCB]/20">
                  <th className="text-left py-3 px-2 text-sm font-semibold text-[#2A9FCB]">Nome</th>
                  <th className="text-left py-3 px-2 text-sm font-semibold text-[#2A9FCB]">Email</th>
                  <th className="text-left py-3 px-2 text-sm font-semibold text-[#2A9FCB]">Telefono</th>
                  <th className="text-left py-3 px-2 text-sm font-semibold text-[#2A9FCB]">Abbonamento</th>
                  <th className="text-left py-3 px-2 text-sm font-semibold text-[#2A9FCB]">Scadenza</th>
                </tr>
              </thead>
              <tbody>
                {getFilteredPatients().map((patient) => (
                  <tr key={patient.id} className="border-b border-[#2A9FCB]/10 hover:bg-white/50">
                    <td className="py-3 px-2">
                      <span className="font-medium text-[#2A9FCB]">
                        {patient.first_name} {patient.last_name}
                      </span>
                    </td>
                    <td className="py-3 px-2 text-sm text-gray-600">{patient.email}</td>
                    <td className="py-3 px-2 text-sm text-gray-600">{patient.phone || '-'}</td>
                    <td className="py-3 px-2">
                      {patient.subscription ? (
                        <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                          patient.subscription.plan_name === 'PREMIUM' 
                            ? 'bg-purple-100 text-purple-700' 
                            : 'bg-blue-100 text-blue-700'
                        }`}>
                          {patient.subscription.plan_name}
                        </span>
                      ) : (
                        <span className="px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-600">
                          Nessuno
                        </span>
                      )}
                    </td>
                    <td className="py-3 px-2 text-sm text-gray-600">
                      {patient.subscription?.expiry_date 
                        ? new Date(patient.subscription.expiry_date).toLocaleDateString('it-IT')
                        : '-'
                      }
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminDashboard;